(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(root) {
      var track = root.querySelector('.js-swol-hero-track');
      var slides = Array.prototype.slice.call(root.querySelectorAll('.js-swol-hero-slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.js-swol-hero-dot'));
      var prevBtn = root.querySelector('.js-swol-hero-prev');
      var nextBtn = root.querySelector('.js-swol-hero-next');
      var count = slides.length;
      if (count < 2) return;

      var effect = root.getAttribute('data-effect') || 'scrollx';
      var infinite = root.getAttribute('data-infinite') === 'true';
      var draggable = root.getAttribute('data-draggable') === 'true';
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 3000;

      var current = 0;
      var autoplayTimer = null;
      var autoplayRemaining = autoplaySpeed;
      var autoplayStartedAt = 0;
      var paused = false;
      var dragState = null;

      function dotFill(index) {
        var d = dots[index];
        return d ? d.querySelector('.js-swol-hero-dot-fill') : null;
      }

      function clampOrWrap(index) {
        if (infinite) return (index + count) % count;
        return Math.max(0, Math.min(count - 1, index));
      }

      function render() {
        slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === current); });
        if (effect === 'scrollx') track.style.transform = 'translateX(-' + current * 100 + '%)';
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === current);
          dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
          var fill = dot.querySelector('.js-swol-hero-dot-fill');
          if (fill) { fill.style.transition = 'none'; fill.style.width = '0'; }
        });
        if (prevBtn) prevBtn.disabled = !infinite && current === 0;
        if (nextBtn) nextBtn.disabled = !infinite && current === count - 1;
        autoplayRemaining = autoplaySpeed;
      }

      function startProgress(duration) {
        if (!autoplay || paused) return;
        var fill = dotFill(current);
        if (!fill) return;
        void fill.offsetWidth;
        fill.style.transition = 'width ' + duration + 'ms linear';
        fill.style.width = '100%';
      }

      function scheduleAutoplay(duration) {
        if (autoplayTimer) { clearTimeout(autoplayTimer); autoplayTimer = null; }
        if (!autoplay || paused) return;
        autoplayRemaining = duration;
        autoplayStartedAt = Date.now();
        autoplayTimer = setTimeout(function () {
          if (infinite || current < count - 1) next();
        }, duration);
      }

      function goTo(index) {
        current = clampOrWrap(index);
        render();
        startProgress(autoplaySpeed);
        scheduleAutoplay(autoplaySpeed);
      }

      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }

      function pause() {
        if (paused) return;
        paused = true;
        if (autoplayTimer) { clearTimeout(autoplayTimer); autoplayTimer = null; }
        if (!autoplay) return;
        var elapsed = Date.now() - autoplayStartedAt;
        autoplayRemaining = Math.max(0, autoplayRemaining - elapsed);
        var fill = dotFill(current);
        if (fill) {
          var w = getComputedStyle(fill).width;
          fill.style.transition = 'none';
          fill.style.width = w;
        }
      }

      function resume() {
        if (!paused) return;
        paused = false;
        if (!autoplay) return;
        startProgress(autoplayRemaining);
        scheduleAutoplay(autoplayRemaining);
      }

      root.addEventListener('mouseenter', pause);
      root.addEventListener('mouseleave', resume);

      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); });
      });

      // touch drag/swipe is always available; mouse drag is gated by the draggable setting
      {
        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' && !draggable) return;
          if (effect !== 'scrollx') return;
          dragState = { startX: e.clientX, width: root.clientWidth, delta: 0, pointerType: e.pointerType };
          root.classList.add('is-dragging');
          track.setPointerCapture(e.pointerId);
          pause();
        });
        track.addEventListener('pointermove', function (e) {
          if (!dragState) return;
          dragState.delta = e.clientX - dragState.startX;
          var base = -current * 100;
          var deltaPct = (dragState.delta / dragState.width) * 100;
          track.style.transform = 'translateX(' + (base + deltaPct) + '%)';
        });
        function endDrag() {
          if (!dragState) return;
          var wasTouch = dragState.pointerType === 'touch';
          root.classList.remove('is-dragging');
          var threshold = dragState.width * 0.15;
          if (dragState.delta > threshold) { prev(); }
          else if (dragState.delta < -threshold) { next(); }
          else { render(); }
          dragState = null;
          if (wasTouch) resume();
        }
        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
      }

      render();
      startProgress(autoplaySpeed);
      scheduleAutoplay(autoplaySpeed);
    }

    document.querySelectorAll('.js-swol-hero-slider').forEach(initSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liquid-shopify-stacksavesnippet"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ALL = '__all';
    const wait = (ms) => new Promise((res) => setTimeout(res, ms));
    const reduceMotion = () =>
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class StackSave {
      constructor(root) {
        this.root = root;
        this.tabs = Array.from(root.querySelectorAll('.js-swol-ss-tag'));
        this.groups = Array.from(root.querySelectorAll('.js-swol-ss-group'));
        this.live = root.querySelector('.js-swol-ss-live');
        this.activeCategory = ALL;

        this.stack = new Map();
        this.inFlight = new Set();

        this.bindTabs();
        this.bindBuilder();
        this.bindFlavorChange();
        this.bindCart();
        this.bindQuickView();
        this.bindCheckout();
        this.bindCarouselKeys();

        this.initTiers();
        this.reconcileCategories();
        this.warnIfStacksInert();
      }

      announce(message) {
        if (this.live) this.live.textContent = message;
      }

      timings() {
        const cs = getComputedStyle(this.root);
        const ms = (name, fallback) => {
          const raw = cs.getPropertyValue(name).trim();
          const n = parseFloat(raw);
          return Number.isFinite(n) ? (raw.endsWith('ms') ? n : n * 1000) : fallback;
        };
        return { dur: ms('--ss-motion-dur', 100), hold: ms('--ss-motion-hold', 500) };
      }

      bindBuilder() {
        this.root.addEventListener('click', (evt) => {
          const step = evt.target.closest('.js-swol-ss-step');
          if (step) {
            this.onStep(step);
            return;
          }
          const cta = evt.target.closest('.js-swol-ss-atb');
          if (cta) this.onAdd(cta);
        });
      }

      bindFlavorChange() {
        this.root.addEventListener('change', (evt) => {
          const flavor = evt.target.closest('.js-swol-ss-flavor');
          if (!flavor) return;

          let card = flavor.closest('.js-swol-ss-card');
          if (!card && this.qv && this.qv.contains(flavor)) {
            card = this.qvSourceCard;
          }
          if (!card) return;

          const opt = flavor.selectedOptions[0];
          const optPrice = opt ? parseInt(opt.dataset.price, 10) : NaN;
          if (!Number.isNaN(optPrice)) {
            card.dataset.price = String(optPrice);
          }

          const id = card.dataset.productId;
          if (this.stack.has(id)) this.onStackChange();
          else this.updateAllCardPrices();

          if (this.qvSourceCard === card) {
            const data = this.catalog()[id] || Object.values(this.catalog()).find((p) => String(p.id) === id);
            if (data) this.updateQuickViewPrice(data, card);
          }
        });
      }

      onAdd(cta) {
        const wrap = cta.closest('.js-swol-ss-atb-wrap');
        if (!wrap) return;
        const id = wrap.dataset.productId;
        const card = this.cardFor(id);
        if (!card) return;

        if (card.dataset.isStack === 'true') {
          this.runStackAddSequence(wrap, card, id);
          return;
        }

        if (this.stack.has(id)) {
          this.setQty(wrap, card, this.stack.get(id) + 1);
          return;
        }

        this.runAddSequence(wrap, card, id);
      }

      explodeStack(wrap, card, id) {
        const data = this.catalog()[id];
        const eligible = ((data && data.members) || []).filter(
          (m) => m.id && m.variantId && m.collectionId && m.available
        );
        if (!eligible.length) return this.runAddSequence(wrap, card, id);
        eligible.forEach((m) => {
          const key = String(m.id);
          this.stack.set(key, (this.stack.get(key) || 0) + 1);
        });
        this.onStackChange();
        return eligible;
      }

      async runStackAddSequence(wrap, card, id) {
        this.inFlight.add(id);
        wrap.setAttribute('aria-busy', 'true');
        this.clearError(wrap);

        const { dur, hold } = this.timings();
        const skip = reduceMotion();

        const eligible = this.explodeStack(wrap, card, id);
        if (!Array.isArray(eligible)) return eligible;

        eligible.forEach((m) => {
          this.syncMemberCard(m.id, this.stack.get(String(m.id)) || 0);
        });

        try {
          if (skip) {
            await this.commitAdd(card, 1);
            this.setFace(wrap, 'cta');
            this.setOpen(wrap, true);
          } else {
            this.setOpen(wrap, false);
            await wait(dur);

            await this.commitAdd(card, 1);

            this.setFace(wrap, 'added');
            this.setOpen(wrap, true);
            await wait(dur + hold);

            this.setOpen(wrap, false);
            await wait(dur);
            this.setFace(wrap, 'cta');
            this.setOpen(wrap, true);
          }

          this.announce(
            eligible.length + (eligible.length === 1 ? ' product' : ' products') +
            ' added to your stack.'
          );

          if (this.qv && (this.qv.hasAttribute('open') || this.qv.classList.contains('is-open')) && this.qv.contains(wrap)) {
            this.closeQuickView();
          }
        } catch (err) {
          eligible.forEach((m) => {
            const key = String(m.id);
            const next = (this.stack.get(key) || 0) - 1;
            if (next > 0) this.stack.set(key, next);
            else this.stack.delete(key);
            this.syncMemberCard(key, next > 0 ? next : 0);
          });
          this.onStackChange();
          this.setFace(wrap, 'cta');
          this.setOpen(wrap, true);
          this.showError(wrap, 'Could not add that. Please try again.');
          this.announce('Those products could not be added to your stack.');
        } finally {
          this.inFlight.delete(id);
          wrap.removeAttribute('aria-busy');
        }
      }

      async runAddSequence(wrap, card, id) {
        this.inFlight.add(id);
        wrap.setAttribute('aria-busy', 'true');
        this.clearError(wrap);

        const { dur, hold } = this.timings();
        const skip = reduceMotion();

        this.stack.set(id, 1);
        this.onStackChange();

        try {
          if (skip) {
            await this.commitAdd(card, 1);
            this.setFace(wrap, 'stepper');
            this.setOpen(wrap, true);
          } else {
            this.setOpen(wrap, false);
            await wait(dur);

            await this.commitAdd(card, 1);

            this.setFace(wrap, 'added');
            this.setOpen(wrap, true);
            await wait(dur + hold);

            this.setOpen(wrap, false);
            await wait(dur);
            this.setFace(wrap, 'stepper');
            this.setOpen(wrap, true);
          }

          this.setQtyLabel(wrap, 1);
          this.announce(`${this.cardTitle(card)} added to your stack.`);

          if (this.qv && (this.qv.hasAttribute('open') || this.qv.classList.contains('is-open')) && this.qv.contains(wrap)) {
            this.closeQuickView();
          }
        } catch (err) {
          this.stack.delete(id);
          this.onStackChange();
          this.setFace(wrap, 'cta');
          this.setOpen(wrap, true);
          this.showError(wrap, 'Could not add that. Please try again.');
          this.announce('That product could not be added to your stack.');
        } finally {
          this.inFlight.delete(id);
          wrap.removeAttribute('aria-busy');
        }
      }

      onStep(btn) {
        const wrap = btn.closest('.js-swol-ss-atb-wrap');
        if (!wrap) return;
        const id = wrap.dataset.productId;
        const card = this.cardFor(id);
        if (!card) return;
        const delta = parseInt(btn.dataset.step, 10) || 0;
        this.setQty(wrap, card, (this.stack.get(id) || 0) + delta);
      }

      setQty(wrap, card, qty) {
        const id = wrap.dataset.productId;

        if (qty <= 0) {
          this.stack.delete(id);
          this.setCardFace(wrap, 0);
          this.onStackChange();
          this.announce(`${this.cardTitle(card)} removed from your stack.`);
          return;
        }

        this.stack.set(id, qty);
        this.setCardFace(wrap, qty);
        this.onStackChange();
        this.announce(`${this.cardTitle(card)}, quantity ${qty}.`);
      }

      setCardFace(wrap, qty) {
        if (qty > 0) {
          this.setFace(wrap, 'stepper');
          this.setOpen(wrap, true);
          this.setQtyLabel(wrap, qty);
        } else {
          this.setFace(wrap, 'cta');
          this.setOpen(wrap, true);
        }
      }

      syncMemberCard(id, qty) {
        const card = this.cardFor(id);
        let wrap = card ? card.querySelector('.js-swol-ss-atb-wrap') : null;
        if (!wrap && card && this.qvSourceCard === card && this.qv) {
          wrap = this.qv.querySelector('.js-swol-ss-atb-wrap');
        }
        if (card && wrap) this.setCardFace(wrap, qty);
      }

      setQtyLabel(wrap, qty) {
        const el = wrap.querySelector('.js-swol-ss-qty');
        if (el) el.textContent = String(qty);
      }

      cardTitle(card) {
        const el = card.querySelector('.swol-ss__card-name');
        return el ? el.textContent.trim() : 'Product';
      }

      setFace(wrap, name) {
        wrap.querySelectorAll('.swol-ss__atb-face').forEach((face) => {
          if (face.dataset.face === name) face.setAttribute('data-current', '');
          else face.removeAttribute('data-current');
        });
      }

      setOpen(wrap, open) {
        if (!open) {
          wrap.removeAttribute('data-open');
          return;
        }
        void wrap.offsetWidth;
        wrap.setAttribute('data-open', '');
      }

      showError(wrap, message) {
        const el = wrap.parentElement
          ? wrap.parentElement.querySelector('.js-swol-ss-atb-error')
          : null;
        if (el) el.textContent = message;
      }

      clearError(wrap) {
        this.showError(wrap, '');
      }

      async commitAdd(card) {
        let flavor = card.querySelector('.js-swol-ss-flavor');
        if (!flavor && this.qvSourceCard === card && this.qv) {
          flavor = this.qv.querySelector('.js-swol-ss-flavor');
        }
        if (flavor && flavor.selectedOptions.length && flavor.selectedOptions[0].disabled) {
          throw new Error('Selected flavor is unavailable.');
        }
        return Promise.resolve();
      }

      bindCheckout() {
        const cta = this.root.querySelector('.js-swol-ss-checkout');
        if (!cta) return;
        cta.addEventListener('click', () => this.submitStack(cta));
      }

      async submitStack(cta) {
        if (this.submitting) return;
        const q = this.quote();
        const min = parseInt(this.root.dataset.atcMinItems, 10) || 1;
        if (q.count < min) return;

        this.submitting = true;
        cta.setAttribute('aria-busy', 'true');
        this.setCartError('');

        const label = this.root.querySelector('.js-swol-ss-checkout-label');
        const restore = label ? label.textContent : '';
        if (label) label.textContent = 'Adding…';

        try {
          const items = await this.buildCartItems(q);
          if (!items || !items.length) throw new Error('No cart items were produced.');

          let res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });

          if (!res.ok && items.some((i) => i.selling_plan)) {
            const fallbackItems = items.map((i) => ({ id: i.id, quantity: i.quantity }));
            res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: fallbackItems })
            });
          }

          if (!res.ok) {
            let detail = '';
            try {
              const body = await res.json();
              detail = body.description || body.message || '';
            } catch (err) {}
            throw new Error(detail || 'Cart rejected the request.');
          }
          const cart = await res.json();

          this.afterAdd(cart, q);
        } catch (err) {
          this.setCartError(
            'We could not add your stack. Nothing has been changed — please try again.'
          );
          this.announce('Your stack could not be added to the cart.');
          console.warn('[stack & save] add to cart failed.', err);
        } finally {
          this.submitting = false;
          cta.removeAttribute('aria-busy');
          if (label) label.textContent = restore;
          this.renderTotals();
        }
      }

      async buildCartItems(q) {
        const api = this.rechargeApi();
        const { productId, variantId } = this.parentIds();
        const planId = this.subscribe ? this.root.dataset.sellingPlanId : '';

        if (api && typeof api.getDynamicBundleItems === 'function') {
          const bundle = {
            externalProductId: String(productId),
            externalVariantId: String(await this.parentVariantFor(q.count, variantId)),
            selections: q.lines.map((line) => {
              const selection = {
                collectionId: String(line.collectionId || ''),
                externalProductId: String(line.id),
                externalVariantId: String(line.variantId),
                quantity: line.qty
              };
              const itemPlanId = line.sellingPlanId || planId;
              if (this.subscribe && itemPlanId) selection.sellingPlan = String(itemPlanId);
              return selection;
            })
          };
          return api.getDynamicBundleItems(bundle);
        }

        return q.lines.map((line) => {
          const item = {
            id: line.variantId,
            quantity: line.qty
          };
          const itemPlanId = line.sellingPlanId || planId;
          if (this.subscribe && itemPlanId && !Number.isNaN(parseInt(itemPlanId, 10))) {
            item.selling_plan = parseInt(itemPlanId, 10);
          }
          return item;
        });
      }

      async parentVariantFor(count, fallback) {
        const settings = await this.loadBundleSettings();
        const variants = (settings && settings.variants) || [];
        if (!variants.length) return fallback;

        const match = variants.find((v) => {
          const min = Number(v.item_count_min ?? v.itemCountMin ?? v.item_count ?? NaN);
          const max = Number(v.item_count_max ?? v.itemCountMax ?? v.item_count ?? NaN);
          if (Number.isFinite(min) && count < min) return false;
          if (Number.isFinite(max) && count > max) return false;
          return true;
        });
        const chosen = match || variants[0];
        return chosen.external_variant_id ?? chosen.externalVariantId ?? chosen.id ?? fallback;
      }

      afterAdd(cart, q) {
        this.root.dispatchEvent(new CustomEvent('on:cart:add', {
          bubbles: true,
          detail: { cart, variantId: q.lines.length ? q.lines[0].variantId : null }
        }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));

        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
          bubbles: true
        }));

        this.announce(
          'Your stack of ' + q.count + (q.count === 1 ? ' product' : ' products') +
          ' was added to your cart.'
        );
      }

      setCartError(message) {
        const el = this.root.querySelector('.js-swol-ss-cart-error');
        if (el) el.textContent = message || '';
      }

      rechargeApi() {
        if (this._rc !== undefined) return this._rc;
        const g = window;
        const roots = [
          g.recharge && g.recharge.bundle,
          g.Recharge && g.Recharge.bundle,
          g.rechargeStorefront && g.rechargeStorefront.bundle,
          g.recharge,
          g.Recharge
        ];
        this._rc = roots.find(
          (r) => r && typeof r.getDynamicBundleItems === 'function'
        ) || null;
        return this._rc;
      }

      parentIds() {
        return {
          productId: this.root.dataset.parentProductId,
          variantId: this.root.dataset.parentVariantId,
          handle: this.root.dataset.parentProductHandle
        };
      }

      async loadBundleSettings() {
        if (this._settings !== undefined) return this._settings;
        const api = this.rechargeApi();
        const { productId } = this.parentIds();
        this._settings = null;

        if (api && typeof api.getCDNBundleSettings === 'function' && productId) {
          try {
            this._settings = await api.getCDNBundleSettings(productId);
          } catch (err) {
            console.warn('[stack & save] getCDNBundleSettings failed.', err);
          }
        }
        return this._settings;
      }

      async initTiers() {
        if (this.cart) this.cart.setAttribute('data-loading', '');
        const settings = await this.loadBundleSettings();
        const parsed = this.parseTiers(settings);
        if (parsed && parsed.length) {
          this._tiers = parsed;
        } else {
          this._tiersAreFallback = true;
        }
        if (this.cart) this.cart.removeAttribute('data-loading');
        this.renderCart();
      }

      parseTiers(settings) {
        if (!settings) return null;
        const raw =
          settings.tiered_discounts ||
          settings.tieredDiscounts ||
          (settings.discount && settings.discount.tiers) ||
          null;
        if (!Array.isArray(raw)) return null;

        return raw
          .map((t) => ({
            min: Number(t.quantity_min ?? t.quantityMin ?? t.min ?? t.quantity),
            pct: Number(t.discount_percentage ?? t.discountPercentage ?? t.percentage ?? t.pct)
          }))
          .filter((t) => Number.isFinite(t.min) && Number.isFinite(t.pct))
          .sort((a, b) => a.min - b.min);
      }

      async reconcileCategories() {
        const settings = await this.loadBundleSettings();
        if (!settings) return;

        const sources = []
          .concat(...(settings.variants || []).map((v) => v.option_sources || []))
          .map((s) => String(s.collection_id ?? s.id ?? s.external_collection_id ?? ''))
          .filter(Boolean);
        if (!sources.length) return;

        const dropped = [];
        this.groups.forEach((group) => {
          const id = String(group.dataset.collectionId || '');
          if (id && !sources.includes(id)) {
            group.setAttribute('hidden', '');
            group.dataset.unsupported = 'true';
            dropped.push(group.dataset.category);
            const tab = this.root.querySelector(
              '.js-swol-ss-tag[data-category="' + group.dataset.category + '"]'
            );
            if (tab) tab.hidden = true;
          }
        });
      }

      quote() {
        const lines = [];
        this.stack.forEach((qty, id) => {
          const card = this.cardFor(id);
          if (card) lines.push(Object.assign(this.productFromCard(card), { qty }));
        });

        const count = lines.reduce((n, l) => n + l.qty, 0);
        const subtotal = lines.reduce((n, l) => n + l.price * l.qty, 0);

        const tierPct = this.earnedPct(count);
        const subPct = this.subscribe ? this.subscribePct() : 0;

        const tierRate = tierPct / 100;
        const subRate = subPct / 100;

        const priced = lines.map((l) => {
          const unit = Math.round(l.price * (1 - tierRate) * (1 - subRate));
          return Object.assign({}, l, { unit, lineTotal: unit * l.qty });
        });
        const total = priced.reduce((n, l) => n + l.lineTotal, 0);

        const gap = subtotal - total;
        const exactStack = subtotal * tierRate;
        const exactSub = subtotal * (1 - tierRate) * subRate;
        const exactGap = exactStack + exactSub;

        let stackDiscount = 0;
        let subDiscount = 0;
        if (gap > 0 && exactGap > 0) {
          stackDiscount = Math.round(gap * (exactStack / exactGap));
          subDiscount = gap - stackDiscount;
        }

        return {
          lines: priced,
          count,
          subtotal,
          tierPct,
          subPct,
          stackDiscount,
          subDiscount,
          total,
          saved: gap
        };
      }

      subscribePct() {
        const raw = parseFloat(this.root.dataset.subscribePct);
        return Number.isFinite(raw) ? raw : 0;
      }

      bindQuickView() {
        this.qv = this.root.querySelector('.js-swol-ss-qv');
        if (!this.qv) return;

        this.qvMain = this.qv.querySelector('.js-swol-ss-qv-main');
        this.qvThumbs = this.qv.querySelector('.js-swol-ss-qv-thumbs');
        this.qvImages = [];
        this.qvIndex = 0;
        this.qvSourceCard = null;

        this.root.addEventListener('click', (evt) => {
          const link = evt.target.closest('.js-swol-ss-quickview');
          if (link) {
            evt.preventDefault();
            this.openQuickView(link);
          }
        });

        this.qv.addEventListener('click', (evt) => {
          if (
            evt.target.closest('.js-close-modal') ||
            evt.target.closest('.swol-ss__qv-close') ||
            evt.target === this.qv
          ) {
            evt.preventDefault();
            this.closeQuickView();
          }
        });

        document.addEventListener('keydown', (evt) => {
          if (
            evt.key === 'Escape' &&
            (this.qv.hasAttribute('open') || this.qv.classList.contains('is-open'))
          ) {
            this.closeQuickView();
          }
        });

        const prev = this.qv.querySelector('.js-swol-ss-qv-prev');
        const next = this.qv.querySelector('.js-swol-ss-qv-next');
        if (prev) prev.addEventListener('click', () => this.showImage(this.qvIndex - 1));
        if (next) next.addEventListener('click', () => this.showImage(this.qvIndex + 1));

        this.qvObserver = new MutationObserver(() => {
          if (!this.qv.hasAttribute('open') && !this.qv.classList.contains('is-open')) {
            this.returnControls();
          }
        });
        this.qvObserver.observe(this.qv, { attributes: true, attributeFilter: ['open', 'class'] });
      }

      catalog() {
        if (this._catalog) return this._catalog;
        const el = this.root.querySelector('.js-swol-ss-data');
        try {
          this._catalog = el ? JSON.parse(el.textContent || '{}') : {};
        } catch (err) {
          this._catalog = {};
        }
        return this._catalog;
      }

      warnIfStacksInert() {
        const cards = this.root.querySelectorAll('.swol-ss__carousel .js-swol-ss-card');
        if (!cards.length) return;

        const catalog = this.catalog();
        const hasContents = Array.from(cards).some((card) => {
          const data = catalog[card.dataset.productId];
          return Boolean(data && Array.isArray(data.members) && data.members.length > 0);
        });
        if (hasContents) return;
      }

      openQuickView(link) {
        const card = link.closest('.js-swol-ss-card');
        if (!card || !this.qv) return;
        const id = String(card.dataset.productId).trim();
        const data = this.catalog()[id] || Object.values(this.catalog()).find((p) => String(p.id) === id);
        if (!data) return;

        this.qvSourceCard = card;
        this.fillQuickView(data, card);

        if (typeof this.qv.show === 'function') this.qv.show(link);
        else if (typeof this.qv.open === 'function') this.qv.open(link);

        this.qv.setAttribute('open', '');
        this.qv.classList.add('is-open', 'active');
        document.body.classList.add('overflow-hidden', 'modal-open');
      }

      fillQuickView(data, card) {
        const q = (sel) => this.qv.querySelector(sel);

        const nameEl = q('.swol-ss__qv-name');
        if (nameEl) nameEl.textContent = data.title || '';

        const badge = q('.js-swol-ss-qv-badge');
        if (badge) badge.hidden = !data.badged;

        const short = q('.js-swol-ss-qv-short');
        if (short) {
          if (this.root.dataset.showShortDesc === 'false') {
            short.hidden = true;
          } else {
            short.innerHTML = data.shortDescription || '';
            short.hidden = !data.shortDescription;
          }
        }

        const chips = q('.js-swol-ss-qv-chips');
        if (chips) {
          chips.textContent = '';
          const members = data.members || [];
          members.forEach((m) => {
            const chip = document.createElement('span');
            chip.className = 'swol-ss__chip';
            chip.textContent = m.title;
            chips.appendChild(chip);
          });
          chips.hidden = members.length === 0;
        }

        this.updateQuickViewPrice(data, card);

        const pps = q('.js-swol-ss-qv-pps');
        if (pps) {
          const cardPps = card.querySelector('.js-swol-ss-pps');
          pps.hidden = !cardPps;
          if (cardPps) pps.textContent = cardPps.textContent.trim();
        }

        this.borrowControls(card);
        this.fillAbout(data);
        this.buildGallery(data);
      }

      updateQuickViewPrice(data, card) {
        if (!this.qv) return;
        const q = this.quote();
        const subPct = this.subscribe ? this.subscribePct() : 0;
        const subRate = subPct / 100;
        const id = String(data.id || (card && card.dataset.productId));

        const flavor = this.qv.querySelector('.js-swol-ss-flavor') || (card && card.querySelector('.js-swol-ss-flavor'));
        const opt = flavor && flavor.selectedOptions.length ? flavor.selectedOptions[0] : null;
        const basePrice = (opt && !Number.isNaN(parseInt(opt.dataset.price, 10)))
          ? parseInt(opt.dataset.price, 10)
          : (data.price || 0);

        const line = q.lines.find((l) => String(l.id) === id);
        let displayPrice = basePrice;
        let originalPrice = card && card.dataset.comparePrice ? parseInt(card.dataset.comparePrice, 10) : basePrice;

        if (line) {
          displayPrice = line.unit;
          originalPrice = line.price;
        } else if (this.subscribe && subRate > 0) {
          displayPrice = Math.round(basePrice * (1 - subRate));
          originalPrice = basePrice;
        }

        const qvPrice = this.qv.querySelector('.js-swol-ss-qv-price');
        let qvWas = this.qv.querySelector('.js-swol-ss-qv-was');

        if (!qvWas && qvPrice && qvPrice.parentNode) {
          qvWas = document.createElement('s');
          qvWas.className = 'swol-ss__card-was swol-ss__num js-swol-ss-qv-was';
          qvPrice.parentNode.appendChild(qvWas);
        }

        if (qvPrice) qvPrice.textContent = this.money(displayPrice);
        if (qvWas) {
          if (originalPrice > displayPrice) {
            qvWas.textContent = this.money(originalPrice);
            qvWas.hidden = false;
          } else {
            qvWas.hidden = true;
          }
        }
      }

      borrowControls(card) {
        const slot = this.qv.querySelector('.js-swol-ss-qv-controls');
        if (!slot) return;
        this.returnControls();

        const flavor = card.querySelector('.js-swol-ss-flavor') || card.querySelector('.js-swol-ss-single-flavor');
        const atb = card.querySelector('.js-swol-ss-atb-wrap');
        const label = flavor && flavor.id ? card.querySelector('label[for="' + flavor.id + '"]') : null;

        this.borrowed = [];
        [label, flavor, atb].forEach((el) => {
          if (!el) return;
          const marker = document.createComment('swol-ss-borrowed');
          el.parentNode.insertBefore(marker, el);
          this.borrowed.push({ el, marker });
          slot.appendChild(el);
        });
      }

      returnControls() {
        if (!this.borrowed || !this.borrowed.length) return;
        this.borrowed.forEach(({ el, marker }) => {
          if (marker.parentNode) marker.parentNode.insertBefore(el, marker);
          if (marker.parentNode) marker.parentNode.removeChild(marker);
        });
        this.borrowed = [];
      }

      fillAbout(data) {
        const about = this.qv.querySelector('.js-swol-ss-qv-about');
        if (!about) return;
        about.textContent = '';

        const addBlock = (title, html, image, withPrefix) => {
          const wrap = document.createElement('div');
          wrap.className = image ? 'swol-ss__qv-member' : '';

          if (image) {
            const media = document.createElement('span');
            media.className = 'swol-ss__qv-member-media';
            const img = document.createElement('img');
            img.src = image;
            img.alt = '';
            img.width = 100;
            img.height = 100;
            img.loading = 'lazy';
            media.appendChild(img);
            wrap.appendChild(media);
          }

          const body = document.createElement('div');
          body.className = 'swol-ss__qv-member-body';
          const h = document.createElement('h3');
          h.className = 'swol-ss__qv-about-title swol-ss__cat-heading';
          h.textContent = withPrefix ? 'About ' + title : title;
          const p = document.createElement('div');
          p.className = 'swol-ss__qv-about-body';
          p.innerHTML = html || '';
          body.appendChild(h);
          body.appendChild(p);
          wrap.appendChild(body);
          about.appendChild(wrap);
        };

        addBlock(data.title, data.description, null, true);
        (data.members || []).forEach((m) => addBlock(m.title, m.description, m.image, false));
      }

      buildGallery(data) {
        this.qvImages = (data.images || []).filter(Boolean);
        this.qvIndex = 0;

        const single = this.qvImages.length <= 1;
        const prev = this.qv.querySelector('.js-swol-ss-qv-prev');
        const next = this.qv.querySelector('.js-swol-ss-qv-next');
        if (prev) prev.hidden = single;
        if (next) next.hidden = single;
        if (this.qvThumbs) this.qvThumbs.hidden = single;

        if (this.qvThumbs) {
          this.qvThumbs.textContent = '';
          this.qvImages.forEach((src, i) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'swol-ss__qv-thumb';
            btn.setAttribute('aria-label', 'Show image ' + (i + 1));
            const img = document.createElement('img');
            img.src = src;
            img.alt = '';
            img.loading = 'lazy';
            btn.appendChild(img);
            btn.addEventListener('click', () => this.showImage(i));
            this.qvThumbs.appendChild(btn);
          });
        }

        this.showImage(0);
      }

      showImage(index) {
        if (!this.qvImages.length) return;
        const total = this.qvImages.length;
        this.qvIndex = ((index % total) + total) % total;
        if (this.qvMain) this.qvMain.src = this.qvImages[this.qvIndex];
        if (this.qvThumbs) {
          Array.from(this.qvThumbs.children).forEach((btn, i) => {
            btn.setAttribute('aria-current', i === this.qvIndex ? 'true' : 'false');
          });
        }
      }

      closeQuickView() {
        if (!this.qv) return;
        if (typeof this.qv.hide === 'function') this.qv.hide();
        if (typeof this.qv.close === 'function') this.qv.close();
        this.qv.removeAttribute('open');
        this.qv.classList.remove('is-open', 'active');
        document.body.classList.remove('overflow-hidden', 'modal-open');
        this.returnControls();
      }

      bindCarouselKeys() {
        const track = this.root.querySelector('.swol-ss__stack-slider');
        if (!track) return;
        track.addEventListener('keydown', (evt) => {
          if (evt.key !== 'ArrowRight' && evt.key !== 'ArrowLeft') return;
          const card = track.querySelector('.swol-ss__stack-item');
          if (!card) return;
          const step = card.getBoundingClientRect().width + 24;
          evt.preventDefault();
          track.scrollBy({
            left: evt.key === 'ArrowRight' ? step : -step,
            behavior: reduceMotion() ? 'auto' : 'smooth'
          });
        });
      }

      bindCart() {
        this.cart = this.root.querySelector('.js-swol-ss-cart');
        this.shell = this.root.querySelector('.js-swol-ss-cart-shell');
        this.lineTpl = this.root.querySelector('.js-swol-ss-line-tpl');
        this.itemsEl = this.root.querySelector('.js-swol-ss-cart-items');
        if (!this.cart) return;

        const toggle = this.root.querySelector('.js-swol-ss-cart-toggle');
        if (toggle) {
          toggle.addEventListener('click', () => this.toggleCart(toggle));
        }

        this.root.addEventListener('click', (evt) => {
          const step = evt.target.closest('.js-swol-ss-line-step');
          if (step) {
            const li = step.closest('.swol-ss__line');
            const delta = parseInt(step.dataset.step, 10) || 0;
            this.setQtyById(li.dataset.productId, (this.stack.get(li.dataset.productId) || 0) + delta);
            return;
          }
          const remove = evt.target.closest('.js-swol-ss-line-remove');
          if (remove) {
            const li = remove.closest('.swol-ss__line');
            this.setQtyById(li.dataset.productId, 0);
          }
        });

        this.root.querySelectorAll('.js-swol-ss-buy').forEach((input) => {
          input.addEventListener('change', () => {
            this.subscribe = input.value === 'subscribe' && input.checked;
            this.renderCart();
          });
        });
        this.subscribe = true;

        this.desktop = window.matchMedia('(min-width: 1024px)');
        const syncViewport = () => {
          if (this.desktop.matches) {
            this.cart.style.height = '';
            this.cart.removeAttribute('data-collapsed');
          } else if (!this.cart.hasAttribute('data-collapsed') && this.stack.size === 0) {
            this.cart.setAttribute('data-collapsed', '');
          }
          if (toggle) {
            const collapsed = this.cart.hasAttribute('data-collapsed');
            toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
            const label = toggle.querySelector('.swol-ss__sr-only');
            if (label) label.textContent = collapsed ? 'Show your stack' : 'Hide your stack';
          }
          this.measureDrawer();
          this.capRail();
        };
        this.desktop.addEventListener('change', syncViewport);
        syncViewport();

        window.addEventListener('scroll', () => {
          cancelAnimationFrame(this._railFrame);
          this._railFrame = requestAnimationFrame(() => this.capRail());
        }, { passive: true });

        window.addEventListener('resize', () => {
          cancelAnimationFrame(this._resizeFrame);
          this._resizeFrame = requestAnimationFrame(() => {
            this.measureDrawer();
            this.capRail();
          });
        }, { passive: true });

        this.renderCart();
        this.measureDrawer();
        this.capRail();
      }

      toggleCart(toggle) {
        const collapsed = this.cart.hasAttribute('data-collapsed');
        if (collapsed) this.expandCart();
        else this.collapseCart();
        toggle.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
        const label = toggle.querySelector('.swol-ss__sr-only');
        if (label) label.textContent = collapsed ? 'Hide your stack' : 'Show your stack';
      }

      expandCart() {
        const from = this.cart.offsetHeight;
        this.cart.removeAttribute('data-collapsed');
        this.cart.style.height = 'auto';
        const to = this.cart.getBoundingClientRect().height;
        this.cart.style.height = from + 'px';
        void this.cart.offsetHeight;
        this.cart.style.height = to + 'px';
        this.settleHeight();
      }

      collapseCart() {
        this.cart.style.height = this.cart.getBoundingClientRect().height + 'px';
        void this.cart.offsetHeight;
        this.cart.setAttribute('data-collapsed', '');
        this.cart.style.height = '';
      }

      settleHeight() {
        clearTimeout(this._heightTimer);
        const dur = parseFloat(getComputedStyle(this.cart).transitionDuration) * 1000 || 0;
        const finish = () => {
          clearTimeout(this._heightTimer);
          this.cart.removeEventListener('transitionend', onEnd);
          if (!this.cart.hasAttribute('data-collapsed')) this.cart.style.height = 'auto';
        };
        const onEnd = (evt) => {
          if (evt.target === this.cart && evt.propertyName === 'height') finish();
        };
        this.cart.addEventListener('transitionend', onEnd);
        this._heightTimer = setTimeout(finish, dur + 60);
      }

      measureDrawer() {
        if (!this.cart || !this.root) return;
        if (this.desktop && this.desktop.matches) return;
        const head = this.cart.querySelector('.swol-ss__cart-head');
        if (!head) return;
        const style = getComputedStyle(this.cart);
        const pad = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
        const next = Math.ceil(head.getBoundingClientRect().height + pad);
        const prev = parseFloat(this.root.style.getPropertyValue('--ss-drawer-h')) || 0;
        if (Math.abs(next - prev) < 1) return;
        this.root.style.setProperty('--ss-drawer-h', next + 'px');
      }

      capRail() {
        if (!this.cart) return;
        if (!this.desktop || !this.desktop.matches) {
          this.cart.style.maxHeight = '';
          return;
        }
        const shell = this.shell || this.root.querySelector('.js-swol-ss-cart-shell');
        if (!shell) return;
        const top = Math.max(shell.getBoundingClientRect().top, 0);
        const next = Math.max(280, Math.round(window.innerHeight - top - 24));
        const prev = parseFloat(this.cart.style.maxHeight) || 0;
        if (Math.abs(next - prev) < 2) return;
        this.cart.style.maxHeight = next + 'px';
      }

      tierConfig() {
        if (this._tiers) return this._tiers;
        return [
          { min: 3, pct: 5 },
          { min: 5, pct: 10 },
          { min: 7, pct: 20 }
        ];
      }

      tierGroups() {
        const tiers = this.tierConfig();
        let prev = 0;
        return tiers.map((t) => {
          const size = t.min - prev;
          prev = t.min;
          return { size, pct: t.pct, min: t.min };
        });
      }

      earnedPct(count) {
        let pct = 0;
        this.tierConfig().forEach((t) => {
          if (count >= t.min) pct = t.pct;
        });
        return pct;
      }

      productFromCard(card) {
        const img = card.querySelector('.swol-ss__card-media img');
        
        let flavor = card.querySelector('.js-swol-ss-flavor');
        if (!flavor && this.qvSourceCard === card && this.qv) {
          flavor = this.qv.querySelector('.js-swol-ss-flavor');
        }

        const opt = flavor && flavor.selectedOptions.length ? flavor.selectedOptions[0] : null;
        const optPrice = opt ? parseInt(opt.dataset.price, 10) : NaN;

        let flavorLabel = '';
        if (opt) {
          flavorLabel = opt.textContent.trim();
          const soldOutSuffix = ' — Sold out';
          if (flavorLabel.slice(-soldOutSuffix.length) === soldOutSuffix) {
            flavorLabel = flavorLabel.slice(0, -soldOutSuffix.length);
          }
        } else {
          const singleFlav = card.querySelector('.js-swol-ss-single-flavor');
          if (singleFlav) flavorLabel = singleFlav.dataset.flavor || '';
        }

        return {
          id: card.dataset.productId,
          variantId: (opt && opt.value) || card.dataset.variantId,
          collectionId: card.dataset.collectionId,
          sellingPlanId: card.dataset.sellingPlanId || '',
          price: Number.isNaN(optPrice) ? (parseInt(card.dataset.price, 10) || 0) : optPrice,
          servings: card.dataset.servings || '',
          title: this.cardTitle(card),
          image: img ? img.currentSrc || img.src : '',
          flavor: flavorLabel
        };
      }

      cardFor(id) {
        return this.root.querySelector('.js-swol-ss-card[data-product-id="' + id + '"]');
      }

      setQtyById(id, qty) {
        const card = this.cardFor(id);
        let wrap = card ? card.querySelector('.js-swol-ss-atb-wrap') : null;

        if (!wrap && card && this.qvSourceCard === card && this.qv) {
          wrap = this.qv.querySelector('.js-swol-ss-atb-wrap');
        }

        if (card && wrap) this.setQty(wrap, card, qty);
      }

      renderCart() {
        if (!this.cart) return;

        const lines = [];
        this.stack.forEach((qty, id) => {
          const card = this.cardFor(id);
          if (card) lines.push(Object.assign(this.productFromCard(card), { qty }));
        });
        const count = lines.reduce((n, l) => n + l.qty, 0);

        this.renderLines(lines);
        this.renderCount(count);
        this.renderTier(count);
        this.renderTotals();
      }

      renderLines(lines) {
        if (!this.itemsEl || !this.lineTpl) return;
        this.itemsEl.textContent = '';

        lines.forEach((line) => {
          const node = this.lineTpl.content.firstElementChild.cloneNode(true);
          node.dataset.productId = line.id;

          const img = node.querySelector('img');
          if (line.image) {
            img.src = line.image;
            img.alt = '';
          } else {
            img.remove();
          }

          node.querySelector('.swol-ss__line-name').textContent = line.title;

          const meta = [line.servings, line.flavor].filter(Boolean).join(' · ');
          const metaEl = node.querySelector('.swol-ss__line-meta');
          if (meta) metaEl.textContent = meta;
          else metaEl.remove();

          node.querySelector('.js-swol-ss-line-qty').textContent = String(line.qty);

          node.querySelector('.swol-ss__line-now').textContent = this.money(line.price * line.qty);
          node.querySelector('.swol-ss__line-was').remove();

          node.querySelectorAll('.js-swol-ss-line-step').forEach((btn) => {
            const dir = btn.dataset.step === '1' ? 'Add one more ' : 'Remove one ';
            btn.setAttribute('aria-label', dir + line.title);
          });
          const rm = node.querySelector('.js-swol-ss-line-remove');
          if (rm) rm.setAttribute('aria-label', 'Remove ' + line.title + ' from your stack');

          this.itemsEl.appendChild(node);
        });

        const empty = this.root.querySelector('.js-swol-ss-cart-empty');
        if (empty) empty.hidden = lines.length > 0;
      }

      renderCount(count) {
        const el = this.root.querySelector('.js-swol-ss-count');
        if (!el) return;
        el.textContent = '(' + count + (count === 1 ? ' item)' : ' items)');
      }

      renderTier(count) {
        const bar = this.root.querySelector('.js-swol-ss-tier');
        if (!bar) return;

        const groups = this.tierGroups();
        const total = groups.reduce((n, g) => n + g.size, 0);

        if (bar.dataset.shape !== groups.map((g) => g.size).join('-')) {
          bar.dataset.shape = groups.map((g) => g.size).join('-');
          bar.textContent = '';
          groups.forEach((g) => {
            const wrap = document.createElement('div');
            wrap.className = 'swol-ss__tier-group';
            const bars = document.createElement('div');
            bars.className = 'swol-ss__tier-bars';
            for (let i = 0; i < g.size; i += 1) {
              const seg = document.createElement('span');
              seg.className = 'swol-ss__tier-seg';
              bars.appendChild(seg);
            }
            const label = document.createElement('span');
            label.className = 'swol-ss__tier-label';
            label.textContent = g.pct + '% off';
            wrap.appendChild(bars);
            wrap.appendChild(label);
            bar.appendChild(wrap);
          });
        }

        const segs = Array.from(bar.querySelectorAll('.swol-ss__tier-seg'));
        segs.forEach((seg, i) => seg.classList.toggle('is-on', i < Math.min(count, total)));

        const pct = this.earnedPct(count);
        const next = this.tierConfig().find((t) => count < t.min);

        bar.setAttribute('aria-valuemax', String(total));
        bar.setAttribute('aria-valuenow', String(Math.min(count, total)));

        let text;
        if (!count) text = 'No products yet. Add ' + this.tierConfig()[0].min + ' to unlock ' + this.tierConfig()[0].pct + '% off.';
        else if (next) text = count + ' of ' + next.min + ' products toward ' + next.pct + '% off.';
        else text = 'Maximum saving unlocked: ' + pct + '% off.';
        bar.setAttribute('aria-valuetext', text);

        const note = this.root.querySelector('.js-swol-ss-tier-note');
        if (note) {
          if (!count) {
            note.textContent = '';
          } else if (next) {
            const away = next.min - count;
            note.innerHTML = '';
            const b = document.createElement('b');
            b.textContent = pct ? "You're saving " + pct + '%.' : 'No discount yet.';
            note.appendChild(b);
            note.appendChild(document.createTextNode(
              ' Add ' + away + (away === 1 ? ' more product' : ' more products') + ' to reach ' + next.pct + '% off.'
            ));
          } else {
            note.innerHTML = '';
            const b = document.createElement('b');
            b.textContent = 'Maximum savings unlocked.';
            note.appendChild(b);
            note.appendChild(document.createTextNode(' ' + pct + '% off applies to ' + this.tierConfig()[this.tierConfig().length - 1].min + ' or more.'));
          }
        }

        this.measureDrawer();
      }

      updateAllCardPrices() {
        const q = this.quote();
        const subPct = this.subscribe ? this.subscribePct() : 0;
        const subRate = subPct / 100;

        this.root.querySelectorAll('.js-swol-ss-card').forEach((card) => {
          const id = card.dataset.productId;
          const priceEl = card.querySelector('.js-swol-ss-card-price');
          let wasEl = card.querySelector('.swol-ss__card-was');
          if (!priceEl) return;

          if (!wasEl && priceEl.parentNode) {
            wasEl = document.createElement('s');
            wasEl.className = 'swol-ss__card-was swol-ss__num';
            priceEl.parentNode.appendChild(wasEl);
          }

          const flavor = card.querySelector('.js-swol-ss-flavor');
          const opt = flavor && flavor.selectedOptions.length ? flavor.selectedOptions[0] : null;
          const basePrice = (opt && !Number.isNaN(parseInt(opt.dataset.price, 10)))
            ? parseInt(opt.dataset.price, 10)
            : (parseInt(card.dataset.price, 10) || 0);

          const line = q.lines.find((l) => l.id === id);
          let displayPrice = basePrice;
          let originalPrice = card.dataset.comparePrice ? parseInt(card.dataset.comparePrice, 10) : basePrice;

          if (line) {
            displayPrice = line.unit;
            originalPrice = line.price;
          } else if (this.subscribe && subRate > 0) {
            displayPrice = Math.round(basePrice * (1 - subRate));
            originalPrice = basePrice;
          }

          priceEl.textContent = this.money(displayPrice);

          if (wasEl) {
            if (originalPrice > displayPrice) {
              wasEl.textContent = this.money(originalPrice);
              wasEl.hidden = false;
            } else {
              wasEl.hidden = true;
            }
          }
        });
      }

      renderTotals() {
        const q = this.quote();
        const min = parseInt(this.root.dataset.atcMinItems, 10) || 1;
        const set = (sel, value) => {
          const el = this.root.querySelector(sel);
          if (el) el.textContent = value;
        };
        const show = (sel, on) => {
          const el = this.root.querySelector(sel);
          if (el) el.hidden = !on;
        };

        set('.js-swol-ss-sum-subtotal-label', 'Subtotal (' + q.count + (q.count === 1 ? ' item)' : ' items)'));
        set('.js-swol-ss-sum-subtotal', q.count ? this.money(q.subtotal) : '—');

        show('.js-swol-ss-sum-stack-row', q.stackDiscount > 0);
        set('.js-swol-ss-sum-stack-label', 'Stack discount (' + q.tierPct + '%)');
        set('.js-swol-ss-sum-stack', '−' + this.money(q.stackDiscount));

        show('.js-swol-ss-sum-sub-row', this.subscribe && q.subDiscount > 0);
        set('.js-swol-ss-sum-sub-label', 'Subscribe discount (' + q.subPct + '%)');
        set('.js-swol-ss-sum-sub', '−' + this.money(q.subDiscount));

        set('.js-swol-ss-sum-total', q.count ? this.money(q.total) : '—');

        const withSub = this.priceFor(true);
        const withoutSub = this.priceFor(false);
        set('.js-swol-ss-price-sub', q.count ? this.money(withSub) : '—');
        set('.js-swol-ss-price-one', q.count ? this.money(withoutSub) : '—');
        const wasSub = this.root.querySelector('.js-swol-ss-was-sub');
        if (wasSub) {
          const showWas = q.count > 0 && withoutSub > withSub;
          wasSub.hidden = !showWas;
          if (showWas) wasSub.textContent = this.money(withoutSub);
        }

        show('.js-swol-ss-fineprint', this.subscribe && q.count > 0);
        const fineprint = this.root.querySelector('.js-swol-ss-fineprint');
        if (fineprint && fineprint.dataset.template) {
          fineprint.textContent = fineprint.dataset.template.replace('{price}', this.money(q.total));
        }

        q.lines.forEach((line) => {
          const li = this.itemsEl
            ? this.itemsEl.querySelector('.swol-ss__line[data-product-id="' + line.id + '"]')
            : null;
          if (!li) return;
          const now = li.querySelector('.swol-ss__line-now');
          if (now) now.textContent = this.money(line.lineTotal);
          let was = li.querySelector('.swol-ss__line-was');
          if (line.unit < line.price) {
            if (!was) {
              was = document.createElement('s');
              was.className = 'swol-ss__line-was swol-ss__num';
              now.parentNode.insertBefore(was, now);
            }
            was.textContent = this.money(line.price * line.qty);
          } else if (was) {
            was.remove();
          }
        });

        this.updateAllCardPrices();
        if (this.qvSourceCard) {
          const id = String(this.qvSourceCard.dataset.productId).trim();
          const data = this.catalog()[id] || Object.values(this.catalog()).find((p) => String(p.id) === id);
          if (data) this.updateQuickViewPrice(data, this.qvSourceCard);
        }

        const cta = this.root.querySelector('.js-swol-ss-checkout');
        const label = this.root.querySelector('.js-swol-ss-checkout-label');
        if (cta) {
          const blocked = false;
          cta.disabled = q.count < min || blocked;
          if (label) {
            if (q.count < min) {
              label.textContent = 'Add ' + min + (min === 1 ? ' product to continue' : ' products to continue');
            } else {
              label.textContent = this.root.dataset.ctaLabel || label.dataset.default || 'Add to Cart';
            }
          }
        }
      }

      priceFor(subscribe) {
        const was = this.subscribe;
        this.subscribe = subscribe;
        const q = this.quote();
        this.subscribe = was;
        return q.total;
      }

      money(cents) {
        const fmt = this.root.dataset.moneyFormat || '$\{\{amount\}\}';
        const amount = (cents / 100).toFixed(2);
        const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return fmt
          .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(cents / 100)));
      }

      onStackChange() {
        const count = Array.from(this.stack.values()).reduce((a, b) => a + b, 0);
        this.root.dataset.stackCount = String(count);
        this.renderCart();
        this.capRail();
      }

      bindTabs() {
        if (!this.tabs.length) return;

        this.root.addEventListener('click', (evt) => {
          const tab = evt.target.closest('.js-swol-ss-tag');
          if (!tab || !this.root.contains(tab)) return;
          this.selectCategory(tab.dataset.category);
        });

        this.tabs.forEach((tab) => {
          tab.addEventListener('keydown', (evt) => this.onTabKeydown(evt, tab));
        });
      }

      onTabKeydown(evt, tab) {
        const i = this.tabs.indexOf(tab);
        let next = -1;

        if (evt.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
        else if (evt.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
        else if (evt.key === 'Home') next = 0;
        else if (evt.key === 'End') next = this.tabs.length - 1;
        else return;

        evt.preventDefault();
        const target = this.tabs[next];
        this.selectCategory(target.dataset.category);
        target.focus();
      }

      selectCategory(category) {
        if (!category) return;
        this.activeCategory = category;

        this.tabs.forEach((tab) => {
          const on = tab.dataset.category === category;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
        });

        this.groups.forEach((group) => {
          if (group.dataset.unsupported === 'true') {
            group.setAttribute('hidden', '');
            return;
          }
          const show = category === ALL || group.dataset.category === category;
          if (show) group.removeAttribute('hidden');
          else group.setAttribute('hidden', '');
        });

        const active = document.activeElement;
        if (active && active.closest && active.closest('.js-swol-ss-group[hidden]')) {
          const tab = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true');
          if (tab) tab.focus();
        }
      }
    }

    const init = (scope) => {
      (scope || document).querySelectorAll('.js-swol-ss').forEach((root) => {
        if (root.dataset.ssReady === 'true') return;
        root.dataset.ssReady = 'true';
        new StackSave(root);
      });
    };

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', () => init());

    document.addEventListener('shopify:section:load', (evt) => init(evt.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  window.swol3Init = function (SID, data) {
  var VARIANTS = data.variants || [];
  var HAS_SUB  = data.hasSub;
  var SERV_OPT_IDX = data.servOptIdx;
  var IS_GEAR  = data.isGear;

  var qty       = 1;
  var purchMode = HAS_SUB ? 'sub' : 'one';
  var curVid    = data.curVid;
  var selOpts   = data.selOpts || [];

  var galleryUrls = data.galleryUrls || [];
  var gIdx = 0;

  function $(id) { return document.getElementById(id + '-' + SID); }
  function cents(n) { return '$' + (n / 100).toFixed(2); }
  function findVariant(opts) {
    if (!VARIANTS || !VARIANTS.length) return null;
    return VARIANTS.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }) || null;
  }

  window['swol3' + SID] = {
    isSwiping: false,

    /* gallery */
    setThumb: function (el) {
      document.querySelectorAll('#swol3Thumbs-' + SID + ' .swol-v3__thumb').forEach(function (t) { t.classList.remove('active'); });
      el.classList.add('active');
      var img = $('swol3Img'); 
      if (img) { 
        img.src = el.dataset.src; 
        img.removeAttribute('srcset'); 
        img.removeAttribute('sizes'); 
      }
      gIdx = [].indexOf.call(document.querySelectorAll('#swol3Thumbs-' + SID + ' .swol-v3__thumb'), el);
      var wrap = $('swol3Wrap'); if (wrap) wrap.classList.remove('zoomed');
    },
    prevImg: function () { if (!galleryUrls.length) return; gIdx = (gIdx - 1 + galleryUrls.length) % galleryUrls.length; this._syncImg(); },
    nextImg: function () { if (!galleryUrls.length) return; gIdx = (gIdx + 1) % galleryUrls.length; this._syncImg(); },
    _syncImg: function () {
      var img = $('swol3Img'); 
      if (img) { 
        img.src = galleryUrls[gIdx]; 
        img.removeAttribute('srcset'); 
        img.removeAttribute('sizes'); 
      }
      document.querySelectorAll('#swol3Thumbs-' + SID + ' .swol-v3__thumb').forEach(function (t, i) { t.classList.toggle('active', i === gIdx); });
    },
    toggleZoom: function (el) { el.classList.toggle('zoomed'); },

    /* variant option pills */
    selectOpt: function (el) {
      var oi = parseInt(el.dataset.optIdx, 10);
      document.querySelectorAll('.swol-v3__opts[data-opt-idx="' + oi + '"] .swol-v3__opt').forEach(function (o) { o.classList.remove('is-active'); });
      el.classList.add('is-active');
      selOpts[oi] = el.dataset.value;
      var v = findVariant(selOpts);
      if (v) this._applyVariant(v);
    },

    _applyVariant: function (v) {
      curVid = v.id;
      var vidEl = $('swol3Vid'); if (vidEl) vidEl.value = v.id;

      var price    = v.price;
      var subPrice = Math.round(price * 0.85);
      var dispPrc  = (purchMode === 'sub' && HAS_SUB) ? subPrice : price;

      var priceEl = $('swol3Price'); if (priceEl) priceEl.textContent = cents(dispPrc);

      var wasEl = $('swol3Was');
      if (wasEl) {
        if (purchMode === 'sub' && HAS_SUB) { wasEl.textContent = cents(price); wasEl.style.display = ''; }
        else if (v.compare_at_price > price) { wasEl.textContent = cents(v.compare_at_price); wasEl.style.display = ''; }
        else { wasEl.style.display = 'none'; }
      }

      var spEl = $('swol3SubPrice'); if (spEl) spEl.textContent = cents(subPrice);
      var opEl = $('swol3OnePrice'); if (opEl) opEl.textContent = cents(price);

      /* Dynamically update servings label */
      var servLbl = $('swol3ServingsLbl');
      if (servLbl) {
        var override = servLbl.getAttribute('data-override');
        if (!override && SERV_OPT_IDX > -1 && v.options[SERV_OPT_IDX]) {
          var sVal = v.options[SERV_OPT_IDX];
          
          if (IS_GEAR) {
            servLbl.textContent = 'Size ' + sVal;
          } else {
            if (sVal.toLowerCase().indexOf('serving') === -1) { sVal += ' Servings'; }
            servLbl.textContent = sVal;
          }
        }
      }

      var btn = $('swol3Atc');
      if (btn) {
        if (v.available) {
          btn.disabled = false;
          btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/><\/svg> Add to Cart';
        } else { btn.disabled = true; btn.textContent = 'Sold Out'; }
      }

      if (v.featured_image) { 
        var imgEl = $('swol3Img'); 
        if (imgEl) { 
          imgEl.src = v.featured_image.src; 
          imgEl.removeAttribute('srcset'); 
          imgEl.removeAttribute('sizes'); 
        } 
      }
    },

    /* subscribe vs one-time */
    selPurchase: function (mode) {
      purchMode = mode;
      var subEl = $('swol3Sub'), oneEl = $('swol3One'), spIn = $('swol3SP');
      if (mode === 'sub') {
        if (subEl) subEl.classList.add('is-active');
        if (oneEl) oneEl.classList.remove('is-active');
        if (spIn) { var iv = $('swol3Interval'); spIn.value = iv ? iv.value : ''; spIn.disabled = false; }
      } else {
        if (subEl) subEl.classList.remove('is-active');
        if (oneEl) oneEl.classList.add('is-active');
        if (spIn) { spIn.value = ''; spIn.disabled = true; }
      }
      var v = VARIANTS.find(function (vv) { return vv.id === curVid; });
      if (v) this._applyVariant(v);
    },

    /* delivery interval → selling plan + price (dev annotation 8504:3973) */
    changeInterval: function () {
      var iv = $('swol3Interval'), spIn = $('swol3SP');
      if (purchMode === 'sub' && iv && spIn) { spIn.value = iv.value; spIn.disabled = false; }
    },

    /* quantity */
    chgQty: function (d) {
      qty = Math.max(1, Math.min(10, qty + d));
      $('swol3QtyN').textContent = qty;
      $('swol3QtyIn').value = qty;
    },

    /* Toggle FBT Item: Add if unselected, Remove if selected */
    toggleFbt: function(btn, vid) {
      if (btn.classList.contains('is-loading')) return;
      
      var isAdding = !btn.classList.contains('on');
      btn.classList.add('is-loading');
      
      // show small loading spinner inside checkbox
      btn.innerHTML = '<svg style="width:12px;height:12px;animation:spin 1s linear infinite;" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" stroke-dasharray="32" stroke-dashoffset="32"/></svg>';
      
      // If we are adding, POST to /add.js with quantity 1. If removing, POST to /change.js with quantity 0.
      var endpoint = isAdding ? '/cart/add.js' : '/cart/change.js';
      var payload = isAdding 
        ? { items: [{ id: parseInt(vid, 10), quantity: 1 }] }
        : { id: vid.toString(), quantity: 0 };

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.classList.remove('is-loading');
        
        if (isAdding) {
          btn.classList.add('on');
          btn.innerHTML = '✓'; 
        } else {
          btn.classList.remove('on');
          btn.innerHTML = ''; 
        }
        
        // Broadcast standard Shopify cart update events so external slide-out carts notice it
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:build'));
        
        // update the free shipping bar live
        window['swol3' + SID].updateShip();
      })
      .catch(function(e) {
        console.error('Error toggling FBT item:', e);
        btn.classList.remove('is-loading');
        btn.innerHTML = isAdding ? '' : '✓';
      });
    },

    /* update live free shipping cart progress */
    updateShip: function() {
      var wrap = $('swol3Ship');
      if (!wrap || !window.fetch) return;
      var threshold = parseInt(wrap.dataset.threshold, 10) || 0;
      if (threshold <= 0) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var total = cart.total_price || 0;
          var pct = Math.min(100, Math.round((total / threshold) * 100));
          var fill = $('swol3ShipFill'); if (fill) fill.style.width = pct + '%';
          var txt = $('swol3ShipText');
          if (txt) {
            if (total >= threshold) { txt.innerHTML = "You've unlocked <b>free shipping</b> 🎉"; }
            else { txt.innerHTML = "You're <b>" + cents(threshold - total) + " away</b> from free shipping"; }
          }
        })
        .catch(function () {});
    },

    /* Scroll to "What Customers Are Saying" section */
    scrollToReviews: function(e) {
      if (e) e.preventDefault();
      
      var target = null;
      
      // 1. Target the actual review widgets directly (Swolverine uses Okendo/Yotpo/etc)
      target = document.querySelector('.okeReviews-widget, .oke-widget, .oke-w-reviews, #stamped-main-widget, .yotpo-main-widget, .jdgm-rev-widg, #shopify-product-reviews');
      
      // 2. If the widget isn't loaded yet, find the heading itself (excluding generic divs/spans)
      if (!target) {
        var headings = document.querySelectorAll('h2, h3, h4, h5, h6');
        for (var i = 0; i < headings.length; i++) {
          var text = headings[i].textContent.trim().toLowerCase();
          if (text.includes('what customers are saying') || text.includes('reviews')) {
            target = headings[i];
            break;
          }
        }
      }

      // 3. Scroll directly to that element
      if (target) {
        var offsetTop = target.getBoundingClientRect().top + window.scrollY - 100; // 100px offset to protect against sticky headers
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      }
    }
  };

  // Setup simple spinner animation rule for FBT buttons (inject once per page)
  if (!document.getElementById('swol3-spin-kf')) {
    var style = document.createElement('style');
    style.id = 'swol3-spin-kf';
    style.innerHTML = '@keyframes spin { 100% { transform: rotate(360deg); } }';
    document.head.appendChild(style);
  }

  // Setup Swipe behavior for main image
  var imgWrap = $('swol3Wrap');
  if (imgWrap) {
    var ts_x = 0;
    imgWrap.addEventListener('touchstart', function(e) {
      ts_x = e.touches[0].clientX;
      window['swol3' + SID].isSwiping = false;
    }, {passive: true});

    imgWrap.addEventListener('touchend', function(e) {
      var te_x = e.changedTouches[0].clientX;
      var diff = ts_x - te_x;

      // If dragged more than 40px, trigger a swipe and block the zoom click
      if (Math.abs(diff) > 40) {
        window['swol3' + SID].isSwiping = true;
        if (diff > 40) window['swol3' + SID].nextImg();
        else window['swol3' + SID].prevImg();
      }
    }, {passive: true});
  }

  /* init */
  window['swol3' + SID].selPurchase(HAS_SUB ? 'sub' : 'one');
  window['swol3' + SID].updateShip();
  };

}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-v3-bottom"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  window.swol3bInit = function (SID) {
  function $(id) { return document.getElementById(id + '-' + SID); }

  window['swol3b' + SID] = {
    /* FAQ: single-open accordion; first open by default */
    toggleFaq: function (btn) {
      var item = btn.closest('.swol-v3b__faq');
      var open = item.classList.contains('is-open');
      var root = $('swol3bFaqs');
      if (root) root.querySelectorAll('.swol-v3b__faq').forEach(function (f) {
        f.classList.remove('is-open');
        var b = f.querySelector('.swol-v3b__faq-head'); if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!open) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    },

    /* reviews topic filter — client-side over Judge.me review cards */
    filterReviews: function (pill) {
      var wrap = $('swol3bRevFilters');
      if (wrap) wrap.querySelectorAll('.swol-v3b__rev-pill').forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      var key = (pill.dataset.key || '').toLowerCase();
      var jdgm = $('swol3bJdgm');
      if (!jdgm) return;
      jdgm.querySelectorAll('.jdgm-rev').forEach(function (rev) {
        if (!key) { rev.style.display = ''; return; }
        rev.style.display = (rev.textContent || '').toLowerCase().indexOf(key) > -1 ? '' : 'none';
      });
    },

    /* Dynamic Pills: hide any filter pill that has no matching keyword in loaded reviews */
    initDynamicFilters: function () {
      var wrap = $('swol3bRevFilters');
      var jdgm = $('swol3bJdgm');
      if (!wrap || !jdgm) return;
      var revs = jdgm.querySelectorAll('.jdgm-rev');
      if (!revs.length) return; 
      
      var allText = '';
      revs.forEach(function (r) { allText += (r.textContent || '').toLowerCase() + ' '; });
      
      wrap.querySelectorAll('.swol-v3b__rev-pill').forEach(function (p) {
        var key = (p.dataset.key || '').toLowerCase();
        if (key && allText.indexOf(key) === -1) {
          p.style.display = 'none';
        } else {
          p.style.display = '';
        }
      });
    },

    /* mirror Judge.me histogram percentages into our dark summary bar */
    syncHistogram: function () {
      var src = document.querySelectorAll('#swol3bJdgm-' + SID + ' .jdgm-histogram__row');
      var hist = $('swol3bHist');
      if (!src.length || !hist) return;
      
      src.forEach(function (row) {
        var pct = 0;

        // 1. Try to find any child element with an inline "width" style (most robust method)
        var barWithWidth = row.querySelector('[style*="width"]');
        if (barWithWidth && barWithWidth.style.width) {
          pct = parseFloat(barWithWidth.style.width.replace(/[^0-9.]/g, ''));
        } else {
          // 2. Fallback: Parse the text inside the frequency/percentage label
          var pctEl = row.querySelector('.jdgm-histogram__frequency, .jdgm-histogram__percentage, .jdgm-histogram__stat');
          if (pctEl && pctEl.textContent) {
             // Look for a number immediately followed by a % sign (e.g. "739 (94%)")
             var match = pctEl.textContent.match(/(\d+(?:\.\d+)?)%/);
             if (match) {
                 pct = parseFloat(match[1]);
             } else {
                 // Absolute fallback, just strip characters
                 pct = parseFloat(pctEl.textContent.replace(/[^0-9.]/g, ''));
             }
          }
        }

        // Safety clamps to prevent the > 100% bug
        if (isNaN(pct)) pct = 0;
        if (pct > 100) pct = 100;

        var n = row.getAttribute('data-rating');
        if (!n) {
          var m = row.className.match(/(\d)-star/);
          if (m) n = m[1];
        }

        if (!n) return;
        
        var target = hist.querySelector('.swol-v3b__rev-hrow[data-star="' + n + '"]');
        if (target) {
          var fill = target.querySelector('.swol-v3b__rev-hrow-fill');
          var lab = target.querySelector('.swol-v3b__rev-hrow-pct');
          if (fill) fill.style.width = pct + '%';
          if (lab) lab.textContent = Math.round(pct) + '%';
        }
      });
    }
  };

  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    var sObj = window['swol3b' + SID];
    sObj.syncHistogram();
    sObj.initDynamicFilters();
    if (tries > 25 || document.querySelectorAll('#swol3bJdgm-' + SID + ' .jdgm-histogram__row').length) clearInterval(iv);
  }, 500);
  };

}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack-save-builder-v2"] && !Shopify.designMode) return;
  try {
    
  /* ═══════════════════════════════════════════════════════════════════════
     SWOLVERINE — STACK & SAVE v2 · builder + cart
     No Liquid in here: config arrives on data-* attributes and Quick View
     content as a JSON script tag. Never write a literal double brace here.
     Ported from the 2026-08 build (swol-stack-save-builder): the Recharge
     adapter, pricing, the clip sequence, the cart cap and Quick View are the
     same logic, rewired to the new markup.
     ═══════════════════════════════════════════════════════════════════════ */
  (() => {
    const ALL = '__all';
    const wait = (ms) => new Promise((res) => setTimeout(res, ms));
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const desktopMQ = window.matchMedia('(min-width: 1024px)');

    class StackBuilder {
      constructor(root) {
        this.root = root;
        this.sid = root.dataset.sid;
        this.cls = (name) => 'swol-ssb-' + this.sid + '__' + name;
        this.live = root.querySelector('.js-ssb-live');
        this.cart = root.querySelector('.js-ssb-cart');
        this.shell = root.querySelector('.js-ssb-shell');
        this.items = root.querySelector('.js-ssb-items');
        this.linesBox = root.querySelector('.js-ssb-lines');
        this.lineTpl = root.querySelector('.js-ssb-line-tpl');
        this.chips = Array.from(root.querySelectorAll('.js-ssb-chip'));
        this.groups = Array.from(root.querySelectorAll('.js-ssb-group'));

        /* productId → { qty, collectionId }. The one source of truth. */
        this.stack = new Map();
        this.inFlight = new Set();
        this.subscribe = true;
        this.lastCount = 0;

        this.bindCatalog();
        this.bindCart();
        this.bindQuickView();
        this.bindCheckout();
        this.renderLadder();
        this.render();

        /* Non-blocking: the page is usable before Recharge answers. */
        this.initTiers();
        this.reconcileCategories();
      }

      announce(msg) { if (this.live) this.live.textContent = msg; }

      timings() {
        const cs = getComputedStyle(this.root);
        const read = (name, fb) => { const n = parseFloat(cs.getPropertyValue(name)); return Number.isFinite(n) ? n : fb; };
        return { dur: read('--ssb-clip', 100), hold: read('--ssb-hold', 500) };
      }

      /* ── catalog: chips, add, steppers, flavour ───────────────────────── */
      bindCatalog() {
        this.root.addEventListener('click', (evt) => {
          const chip = evt.target.closest('.js-ssb-chip');
          if (chip) return this.selectCategory(chip.dataset.category);
          const step = evt.target.closest('.js-ssb-step');
          if (step) {
            const id = step.closest('.js-ssb-atb').dataset.productId;
            return this.setQty(id, this.qtyOf(id) + (parseInt(step.dataset.step, 10) || 0));
          }
          const cta = evt.target.closest('.js-ssb-atb-cta');
          if (cta) this.onAdd(cta);
        });

        /* The <select> is the variant source of truth. Duplicate cards (a
           product in two categories) are kept on the same flavour. */
        this.root.addEventListener('change', (evt) => {
          const sel = evt.target.closest('.js-ssb-flavor');
          if (!sel) return;
          const card = sel.closest('.js-ssb-card');
          const id = card.dataset.productId;
          this.cardsFor(id).forEach((c) => {
            const other = c.querySelector('.js-ssb-flavor');
            if (other && other !== sel) other.value = sel.value;
            this.paintCardPrice(c);
          });
          if (this.stack.has(id)) this.render();
        });
      }

      paintCardPrice(card) {
        const sel = card.querySelector('.js-ssb-flavor');
        const opt = sel && sel.selectedOptions[0];
        if (!opt || !opt.dataset.price) return;
        const price = parseInt(opt.dataset.price, 10);
        const compare = parseInt(opt.dataset.compare, 10) || price;
        const p = card.querySelector('.js-ssb-card-price');
        if (p) p.textContent = this.money(price);
        const w = card.querySelector('.js-ssb-card-was');
        if (w) { w.hidden = !(compare > price); w.textContent = this.money(compare); }
      }

      selectCategory(category) {
        if (!category) return;
        this.chips.forEach((c) => c.setAttribute('aria-pressed', c.dataset.category === category ? 'true' : 'false'));
        const show = this.groups.filter((g) => g.dataset.unsupported !== 'true' && (category === ALL || g.dataset.category === category));
        const run = (this._filterRun = (this._filterRun || 0) + 1);
        const visible = this.groups.filter((g) => !g.hidden);
        const apply = () => {
          if (run !== this._filterRun) return;
          this.groups.forEach((g) => { g.classList.remove('is-out', 'is-in'); g.hidden = !show.includes(g); });
          if (!reduceMotion()) {
            let i = 0;
            show.forEach((g) => {
              g.querySelector('h3').style.setProperty('--i', Math.min(i++, 8));
              g.querySelectorAll('.js-ssb-card').forEach((c) => c.style.setProperty('--i', Math.min(i++, 8)));
              void g.offsetWidth;
              g.classList.add('is-in');
            });
          }
          /* Don't strand focus inside a group that just hid. */
          const active = document.activeElement;
          if (active && active.closest && active.closest('.js-ssb-group[hidden]')) {
            const chip = this.chips.find((c) => c.getAttribute('aria-pressed') === 'true');
            if (chip) chip.focus();
          }
          /* Bring the catalog head back into view if the filter left the
             visitor below the new, shorter content. */
          const head = this.root.querySelector('.' + this.cls('head'));
          if (head && head.getBoundingClientRect().top < 0) {
            head.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
          }
        };
        if (reduceMotion() || !visible.length) return apply();
        visible.forEach((g) => g.classList.add('is-out'));
        setTimeout(apply, 150);
      }

      /* ── Add to Builder ───────────────────────────────────────────────── */
      onAdd(cta) {
        const wrap = cta.closest('.js-ssb-atb');
        const card = cta.closest('.js-ssb-card');
        const id = wrap.dataset.productId;
        if (this.inFlight.has(id)) return;
        if (this.stack.has(id)) return this.setQty(id, this.qtyOf(id) + 1);
        this.runAddSequence(wrap, card, id);
      }

      async runAddSequence(wrap, card, id) {
        this.inFlight.add(id);
        wrap.setAttribute('aria-busy', 'true');
        this.setError(card, '');
        const { dur, hold } = this.timings();
        const sel = card.querySelector('.js-ssb-flavor');
        if (sel && sel.selectedOptions[0] && sel.selectedOptions[0].disabled) {
          this.setError(card, 'That flavor is sold out. Pick another.');
          this.inFlight.delete(id);
          wrap.removeAttribute('aria-busy');
          return;
        }

        /* Numbers update on CLICK — the animation never gates the cart. The
           stepper's count is written now too, before its face ever opens:
           a card that was taken back to 0 earlier still says "0" until it
           is (the review-round-1 "stepper 0, builder 1" bug). */
        this.stack.set(id, { qty: 1, collectionId: card.dataset.collectionId, card });
        this.render({ added: id });
        this.syncCards(id);

        try {
          if (reduceMotion() || dur === 0) {
            this.setFace(wrap, 'stepper');
          } else {
            this.setOpen(wrap, false); await wait(dur);
            this.setFace(wrap, 'added'); this.setOpen(wrap, true); await wait(dur + hold);
            this.setOpen(wrap, false); await wait(dur);
            this.setFace(wrap, 'stepper'); this.setOpen(wrap, true);
          }
          this.announce(this.titleOf(card) + ' added to your stack.');
          if (this.qv && this.qv.hasAttribute('open') && this.qv.contains(wrap)) this.closeQuickView();
        } finally {
          this.inFlight.delete(id);
          wrap.removeAttribute('aria-busy');
          /* Reconcile the face too, in case the quantity changed from the
             cart while the sequence was running. */
          this.syncCards(id);
        }
      }

      setFace(wrap, name) {
        wrap.querySelectorAll('[data-face]').forEach((f) => f.toggleAttribute('data-current', f.dataset.face === name));
      }
      /* A layout read between the visibility change and the clip change, or
         the browser folds both into one frame and nothing animates. */
      setOpen(wrap, open) {
        if (!open) return wrap.removeAttribute('data-open');
        void wrap.offsetWidth;
        wrap.setAttribute('data-open', '');
      }
      setError(card, msg) { const el = card && card.querySelector('.js-ssb-err'); if (el) el.textContent = msg; }

      qtyOf(id) { const e = this.stack.get(id); return e ? e.qty : 0; }
      cardsFor(id) { return Array.from(this.root.querySelectorAll('.js-ssb-card[data-product-id="' + id + '"]')); }
      titleOf(card) { const el = card && card.querySelector('.js-ssb-name'); return el ? el.textContent.trim() : 'Product'; }

      setQty(id, qty) {
        const entry = this.stack.get(id);
        const card = (entry && entry.card) || this.cardsFor(id)[0];
        if (!card) return;
        if (qty <= 0) {
          this.stack.delete(id);
          this.render();
          this.announce(this.titleOf(card) + ' removed from your stack.');
        } else {
          const before = entry ? entry.qty : 0;
          if (entry) entry.qty = qty;
          else this.stack.set(id, { qty, collectionId: card.dataset.collectionId, card });
          this.render({ added: qty > before ? id : null });
          this.announce(this.titleOf(card) + ', quantity ' + qty + '.');
        }
        this.syncCards(id);
      }

      /* Every card for this product mirrors the stack: stepper while in it,
         the CTA once it isn't. Instant — removal should feel immediate.
         The count is ALWAYS written; only the face swap waits for a card
         that is mid-animation, which reconciles itself when it finishes. */
      syncCards(id) {
        const qty = this.qtyOf(id);
        this.root.querySelectorAll('.js-ssb-atb[data-product-id="' + id + '"]').forEach((wrap) => {
          const q = wrap.querySelector('.js-ssb-qty');
          if (q) q.textContent = String(qty);
          if (wrap.getAttribute('aria-busy') === 'true') return;
          this.setFace(wrap, qty > 0 ? 'stepper' : 'cta');
          wrap.setAttribute('data-open', '');
        });
      }

      /* ── product data off the card (the grid IS the catalog) ─────────── */
      productFrom(id) {
        const entry = this.stack.get(id);
        const card = (entry && entry.card) || this.cardsFor(id)[0];
        const sel = card.querySelector('.js-ssb-flavor');
        const opt = sel && sel.selectedOptions.length ? sel.selectedOptions[0] : null;
        const num = (v, fb) => { const n = parseInt(v, 10); return Number.isNaN(n) ? fb : n; };
        const price = opt ? num(opt.dataset.price, num(card.dataset.price, 0)) : num(card.dataset.price, 0);
        let flavor = opt ? opt.textContent.trim() : '';
        const suffix = ' — Sold out';
        if (flavor.slice(-suffix.length) === suffix) flavor = flavor.slice(0, -suffix.length);
        const img = card.querySelector('.' + this.cls('media') + ' img');
        return {
          id,
          variantId: (opt && opt.value) || card.dataset.variantId,
          collectionId: (entry && entry.collectionId) || card.dataset.collectionId,
          price,
          servings: (opt && opt.dataset.servings) || card.dataset.servings || '',
          flavor,
          title: this.titleOf(card),
          image: img ? img.currentSrc || img.src : ''
        };
      }

      /* ══════════════════════════════════════════════════════════════════
         PRICING — one quote, multiplicative. Subscription applies to the
         already-discounted price: 20% then 15% is 32% off, not 35%.
         Per-unit prices round first so lines sum to the total; the two
         discount rows are allocated from the REAL gap so they reconcile.
         ══════════════════════════════════════════════════════════════════ */
      quote(subscribe = this.subscribe) {
        const lines = [];
        this.stack.forEach((e, id) => lines.push(Object.assign(this.productFrom(id), { qty: e.qty })));
        const count = lines.reduce((n, l) => n + l.qty, 0);
        const subtotal = lines.reduce((n, l) => n + l.price * l.qty, 0);
        const tierPct = this.earnedPct(count);
        const subPct = subscribe ? this.subscribePct() : 0;
        const tr = tierPct / 100, sr = subPct / 100;
        const priced = lines.map((l) => {
          const unit = Math.round(l.price * (1 - tr) * (1 - sr));
          return Object.assign({}, l, { unit, lineTotal: unit * l.qty });
        });
        const total = priced.reduce((n, l) => n + l.lineTotal, 0);
        const gap = subtotal - total;
        const exStack = subtotal * tr, exSub = subtotal * (1 - tr) * sr, exGap = exStack + exSub;
        let stackDiscount = 0, subDiscount = 0;
        if (gap > 0 && exGap > 0) { stackDiscount = Math.round(gap * (exStack / exGap)); subDiscount = gap - stackDiscount; }
        return { lines: priced, count, subtotal, tierPct, subPct, stackDiscount, subDiscount, total };
      }
      subscribePct() { const n = parseFloat(this.root.dataset.subscribePct); return Number.isFinite(n) ? n : 0; }

      /* Tiers are READ from Recharge. This fallback is the design's ladder,
         for display only — Add to Cart stays disabled while it's in use. */
      tierConfig() { return this._tiers || [{ min: 2, pct: 5 }, { min: 3, pct: 10 }, { min: 4, pct: 20 }]; }
      earnedPct(count) { let p = 0; this.tierConfig().forEach((t) => { if (count >= t.min) p = t.pct; }); return p; }

      /* ── render ───────────────────────────────────────────────────────── */
      render(opts = {}) {
        const q = this.quote();
        /* Mark the peek BEFORE the tier bar updates: the fill transition
           starts at the next style recalc, and it must see .is-peeking to
           pick up its delay. */
        const willPeek = q.count > this.lastCount && this.canPeek();
        if (willPeek) this.cart.classList.add('is-peeking');
        this.renderLines(q, opts.added);
        this.renderCount(q.count);
        this.renderTier(q.count);
        this.renderTotals(q);
        if (willPeek) this.peek();
        this.lastCount = q.count;
        if (this.cart.hasAttribute('data-open')) this.sizeSheet();
        this.updateMore();
      }

      /* Add while the mobile sheet is closed: PEEK. The sheet rises just far
         enough to show the nudge line and the tier ladder (the whole head),
         holds, then tucks back to 84px — the sheet's own 500ms ease-in-out
         both ways. Another add during the hold restarts it. Opening, closing
         or dragging the sheet cancels it. Reduced motion: no peek (the count
         and the live region still confirm the add). */
      canPeek() { return !desktopMQ.matches && !this.cart.hasAttribute('data-open') && !reduceMotion(); }

      peek() {
        if (!this.canPeek()) return;
        const head = this.root.querySelector('.js-ssb-cart-head');
        const cs = getComputedStyle(this.cart);
        const h = Math.ceil(head.getBoundingClientRect().height + parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom));
        this.cart.classList.add('is-peeking');
        this.cart.style.height = h + 'px';
        clearTimeout(this._peekTimer);
        this._peekTimer = setTimeout(() => this.unpeek(), 500 + 1600);
      }

      unpeek(keepHeight) {
        clearTimeout(this._peekTimer);
        if (!this.cart.classList.contains('is-peeking')) return;
        this.cart.classList.remove('is-peeking');
        if (!keepHeight && !this.cart.hasAttribute('data-open')) this.cart.style.removeProperty('height');
      }

      /* The "view more" cues. Each one shows only while ITS scroller has
         content below and the cart is on screen (the rail, or the open
         sheet): the list cue for rows past the second, the body cue when the
         cart itself is cut off on a short screen. The body cue's own height
         and gap are discounted, so showing it can't be why it shows. */
      updateMore() {
        const listCue = this.root.querySelector('.js-ssb-more');
        const bodyCue = this.root.querySelector('.js-ssb-more-body');
        const body = this.root.querySelector('.js-ssb-body');
        if (!listCue || !bodyCue || !body) return;
        const visible = desktopMQ.matches || this.cart.hasAttribute('data-open');
        const L = this.linesBox;
        listCue.hidden = !(visible && L.scrollHeight - L.clientHeight - L.scrollTop > 2);
        const own = bodyCue.hidden ? 0 : bodyCue.offsetHeight + (parseFloat(getComputedStyle(body).rowGap) || 0);
        bodyCue.hidden = !(visible && body.scrollHeight - own - body.clientHeight - body.scrollTop > 2);
      }

      /* Rows are reconciled, not rebuilt: existing rows update in place, new
         ones open in, removed ones close out — so the motion has something
         to animate and focus inside the list survives. NEWEST FIRST (review
         round 2): a new row opens at the top and pushes the others down, so
         the product just added is always in view and anything the panel
         hides is always below — where the "view more" cue points. */
      renderLines(q, addedId) {
        const want = new Map(q.lines.map((l) => [String(l.id), l]));
        Array.from(this.items.children).forEach((li) => {
          if (li.classList.contains('is-leaving')) return;
          if (!want.has(li.dataset.productId)) this.closeLine(li);
        });
        q.lines.forEach((line) => {
          let li = this.items.querySelector('li[data-product-id="' + line.id + '"]:not(.is-leaving)');
          if (!li) {
            li = this.lineTpl.content.firstElementChild.cloneNode(true);
            li.dataset.productId = line.id;
            this.items.prepend(li);
            this.bindSwipe(li);
            if (reduceMotion()) li.classList.remove('is-entering');
            else { void li.offsetWidth; li.classList.remove('is-entering'); }
            if (String(addedId) === String(line.id)) {
              this.linesBox.scrollTo({ top: 0, behavior: reduceMotion() ? 'auto' : 'smooth' });
            }
          }
          const img = li.querySelector('img');
          if (line.image) { if (img.getAttribute('src') !== line.image) img.src = line.image; } else img.removeAttribute('src');
          li.querySelector('.' + this.cls('line-name')).textContent = line.title;
          li.querySelector('.' + this.cls('line-meta')).textContent = [line.servings, line.flavor].filter(Boolean).join(' · ');
          li.querySelector('.js-ssb-line-qty').textContent = String(line.qty);
          li.querySelector('.' + this.cls('line-was')).textContent = line.unit < line.price ? this.money(line.price * line.qty) : '';
          li.querySelector('.' + this.cls('line-now')).textContent = this.money(line.lineTotal);
          li.querySelectorAll('.js-ssb-line-step').forEach((b) => b.setAttribute('aria-label', (b.dataset.step === '1' ? 'Add one more ' : 'Remove one ') + line.title));
          li.querySelector('.js-ssb-line-rm').setAttribute('aria-label', 'Remove ' + line.title + ' from your stack');
        });
        const empty = this.root.querySelector('.js-ssb-empty');
        if (empty) empty.hidden = q.lines.length > 0;
      }

      closeLine(li) {
        if (reduceMotion()) return li.remove();
        li.classList.add('is-leaving');
        const done = () => li.remove();
        li.addEventListener('transitionend', (e) => { if (e.target === li && e.propertyName === 'opacity') done(); }, { once: true });
        setTimeout(done, 360); /* transitionend isn't guaranteed */
      }

      /* One way out for a row, from the trash button or a swipe: it slides
         off to the left over the red swoosh, THEN leaves the stack, and the
         line closes up. Focus inside the row moves to the list so keyboard
         users aren't dropped on <body>. */
      deleteLine(li) {
        if (!li || li.classList.contains('is-deleting') || li.classList.contains('is-leaving')) return;
        const id = li.dataset.productId;
        if (li.contains(document.activeElement)) this.linesBox.focus({ preventScroll: true });
        if (reduceMotion()) return this.setQty(id, 0);
        const row = li.querySelector('.' + this.cls('row'));
        li.classList.remove('is-swiping');
        li.classList.add('is-deleting');
        row.style.transition = '';
        row.style.transform = 'translateX(-100%)';
        setTimeout(() => { if (this.stack.has(id)) this.setQty(id, 0); }, 300);
      }

      /* Swipe left past 40% of the row to delete, below 1024. Pointer
         capture keeps the gesture alive when the finger leaves the row;
         touch-action: pan-y hands vertical drags to the scroller (the
         browser then sends pointercancel). Mouse drags are allowed below
         1024 too, so the gesture can be tried in a desktop browser. */
      bindSwipe(li) {
        const row = li.querySelector('.' + this.cls('row'));
        let x0 = null, y0 = 0, dx = 0, locked = null;
        row.addEventListener('pointerdown', (e) => {
          if (desktopMQ.matches || e.target.closest('button') || li.classList.contains('is-deleting')) return;
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          x0 = e.clientX; y0 = e.clientY; dx = 0; locked = null;
          try { row.setPointerCapture(e.pointerId); } catch (err) { /* already released */ }
        });
        row.addEventListener('pointermove', (e) => {
          if (x0 === null) return;
          const mx = e.clientX - x0, my = e.clientY - y0;
          if (locked === null && (Math.abs(mx) > 6 || Math.abs(my) > 6)) locked = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
          if (locked !== 'x') return;
          e.preventDefault();
          dx = Math.min(0, mx);
          li.classList.toggle('is-swiping', dx < -4);
          row.style.transition = 'none';
          row.style.transform = 'translateX(' + dx + 'px)';
        });
        const end = () => {
          if (x0 === null) return;
          x0 = null;
          row.style.transition = '';
          if (locked === 'x' && dx < -row.offsetWidth * 0.4) this.deleteLine(li);
          else { row.style.transform = ''; li.classList.remove('is-swiping'); }
        };
        row.addEventListener('pointerup', end);
        row.addEventListener('pointercancel', end);
      }

      renderCount(count) {
        const el = this.root.querySelector('.js-ssb-count');
        el.textContent = count + (count === 1 ? ' item' : ' items');
        if (count !== this.lastCount && !reduceMotion()) { el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); }
      }

      /* Segment count is DERIVED from the thresholds: tier n spans
         (min[n-1], min[n]] items, one sub-segment per item. 2/3/4 → 2,1,1. */
      renderLadder() {
        const ladder = this.root.querySelector('.js-ssb-ladder');
        const tiers = this.tierConfig();
        const shape = tiers.map((t) => t.min + ':' + t.pct).join(',');
        if (ladder.dataset.shape === shape) return;
        ladder.dataset.shape = shape;
        ladder.textContent = '';
        let prev = 0;
        tiers.forEach((t) => {
          const tier = document.createElement('div');
          tier.className = this.cls('tier');
          tier.dataset.min = t.min;
          const segs = document.createElement('div');
          segs.className = this.cls('segs');
          for (let i = prev + 1; i <= t.min; i += 1) {
            const seg = document.createElement('span');
            seg.className = this.cls('seg');
            seg.dataset.at = i;
            segs.appendChild(seg);
          }
          prev = t.min;
          const label = document.createElement('span');
          label.className = this.cls('tier-label');
          label.textContent = t.pct + '% off';
          tier.append(segs, label);
          ladder.appendChild(tier);
        });
        ladder.setAttribute('aria-valuemax', String(prev));
      }

      renderTier(count) {
        const ladder = this.root.querySelector('.js-ssb-ladder');
        const tiers = this.tierConfig();
        const max = tiers[tiers.length - 1].min;
        ladder.querySelectorAll('.' + this.cls('seg')).forEach((seg) => seg.classList.toggle('is-on', count >= +seg.dataset.at));
        ladder.querySelectorAll('.' + this.cls('tier')).forEach((tier) => {
          const hit = count >= +tier.dataset.min;
          const was = tier.classList.contains('is-hit');
          tier.classList.toggle('is-hit', hit);
          tier.classList.remove('is-new');
          if (hit && !was && !reduceMotion()) { void tier.offsetWidth; tier.classList.add('is-new'); }
        });
        const pct = this.earnedPct(count);
        const next = tiers.find((t) => count < t.min);
        ladder.setAttribute('aria-valuenow', String(Math.min(count, max)));
        ladder.setAttribute('aria-valuetext', !count
          ? 'No products yet. Add ' + tiers[0].min + ' to unlock ' + tiers[0].pct + '% off.'
          : next ? count + ' of ' + next.min + ' products toward ' + next.pct + '% off.'
          : 'Maximum saving unlocked: ' + pct + '% off.');
        this.setNudge(count, next, pct);
      }

      /* With One-Time Purchase selected, any tier that already earns a
         discount below the top adds "Subscribe to save more." after the
         next-tier nudge (Chance, review round 3). The top tier has its own
         two versions: one-time asks for the subscription with the full
         figure, subscribed confirms it. {total} is the two discounts
         compounded — 1 − 0.80 × 0.85 = 32%. The purchase type is part of the
         key wherever it changes the words, so switching it slides the new
         line in. */
      setNudge(count, next, pct) {
        const d = this.root.dataset;
        const askSub = !this.subscribe && pct > 0;
        const key = !count ? 'empty'
          : next ? 'next' + next.min + (askSub ? '-one' : '')
          : 'max-' + (this.subscribe ? 'sub' : 'one');
        if (this._nudgeKey === key) return;
        this._nudgeKey = key;
        const span = document.createElement('span');
        if (!count) { span.className = 'is-empty'; span.textContent = d.nudgeEmpty; }
        else if (next) {
          let text = (d.nudgeNext || 'Add {count} more to save {percent}%')
            .replace('{count}', next.min - count).replace('{percent}', next.pct);
          if (askSub) {
            const extra = d.nudgeSubscribe || 'Subscribe to save more.';
            text = text.replace(/\s+$/, '') + (/[.!?]$/.test(text.trim()) ? ' ' : '. ') + extra;
          }
          span.textContent = text;
        } else {
          const sub = this.subscribePct();
          const total = Math.round((1 - (1 - pct / 100) * (1 - sub / 100)) * 100);
          const tpl = this.subscribe
            ? (d.nudgeMaxSub || "You've unlocked the full {total}% off.")
            : (d.nudgeMax || "You've unlocked {percent}% off. Subscribe to get the full {total}%.");
          span.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="#22c55e"/><path d="M4.5 8.2l2.3 2.3 4.7-4.8" stroke="#fff" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          span.append(tpl.replace(/\{percent\}/g, pct).replace(/\{sub\}/g, sub).replace(/\{total\}/g, total));
        }
        const box = this.root.querySelector('.js-ssb-nudge');
        const old = Array.from(box.children);
        box.appendChild(span);
        /* Closed mobile sheet: swap instantly — the peek reveals the new line,
           and a slide here would flash the old one as the sheet rises. */
        const collapsed = !desktopMQ.matches && !this.cart.hasAttribute('data-open');
        if (reduceMotion() || collapsed) return old.forEach((o) => o.remove());
        span.classList.add('is-entering');
        old.forEach((o) => o.classList.add('is-leaving'));
        void span.offsetWidth;
        span.classList.remove('is-entering');
        setTimeout(() => old.forEach((o) => o.remove()), 220);
      }

      renderTotals(q) {
        const $ = (sel) => this.root.querySelector(sel);
        const has = q.count > 0;
        $('.js-ssb-sum-sub-label').textContent = 'Subtotal (' + q.count + (q.count === 1 ? ' item)' : ' items)');
        $('.js-ssb-sum-stack-label').textContent = 'Stack Discount (' + q.tierPct + '%)';
        this.tick($('.js-ssb-sum-sub'), has ? q.subtotal : null);
        this.tick($('.js-ssb-sum-stack'), has ? q.stackDiscount : null, '- ');
        this.tick($('.js-ssb-sum-subs'), has && this.subscribe ? q.subDiscount : null, '- ');
        this.tick($('.js-ssb-total'), has ? q.total : null);

        /* Both options carry their own live total, so the choice is priced. */
        const sub = this.quote(true).total, one = this.quote(false).total;
        this.tick($('.js-ssb-price-sub'), has ? sub : null);
        this.tick($('.js-ssb-price-one'), has ? one : null);
        $('.js-ssb-was-sub').textContent = has && one > sub ? this.money(one) : '';

        const fine = $('.js-ssb-fine');
        fine.hidden = !this.subscribe;
        fine.textContent = (fine.dataset.template || '').replace('{price}', has ? this.money(q.total) : '{price}');

        /* The CTA states the requirement, never the shortfall, and stays off
           while Recharge is unreachable: a total we can't honour is worse
           than no button. */
        const cta = $('.js-ssb-checkout');
        const label = $('.js-ssb-checkout-label');
        const min = parseInt(this.root.dataset.atcMinItems, 10) || 1;
        const blocked = this._tiersAreFallback === true || this._sdkMissing === true;
        cta.disabled = q.count < min || blocked || this.submitting === true;
        if (this.submitting) return;
        if (!has) label.textContent = this.root.dataset.emptyCtaLabel || 'Add a product';
        else if (q.count < min) label.textContent = 'Add ' + min + ' products to continue';
        else if (blocked) label.textContent = 'Temporarily unavailable';
        else label.textContent = this.root.dataset.ctaLabel || 'Add to Cart';
      }

      /* Money swaps straight to its new value — no count-up (Chance,
         review round 5; the 400ms tick was removed). */
      tick(el, cents, prefix = '') {
        if (!el) return;
        el.textContent = cents === null ? '—' : prefix + this.money(cents);
      }

      money(cents) {
        /* Escaped braces: a literal pair would be read as Liquid output. */
        const fmt = this.root.dataset.moneyFormat || '$\{\{amount\}\}';
        const amount = (cents / 100).toFixed(2);
        const commas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return fmt
          .replace(/\{\{\s*amount\s*\}\}/g, commas)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(cents / 100)));
      }

      /* ── cart: lines, purchase type, sheet, rail cap ──────────────────── */
      bindCart() {
        this.root.addEventListener('click', (evt) => {
          const li = evt.target.closest('.js-ssb-items > li');
          if (li && li.classList.contains('is-deleting')) return;
          const step = evt.target.closest('.js-ssb-line-step');
          if (step) {
            const id = li.dataset.productId;
            return this.setQty(id, this.qtyOf(id) + (parseInt(step.dataset.step, 10) || 0));
          }
          const rm = evt.target.closest('.js-ssb-line-rm');
          if (rm) return this.deleteLine(li);
        });
        this.root.querySelectorAll('.js-ssb-buy').forEach((input) => input.addEventListener('change', () => {
          this.subscribe = input.value === 'subscribe' && input.checked;
          this.render();
        }));

        this.toggle = this.root.querySelector('.js-ssb-toggle');
        if (this.toggle) this.toggle.addEventListener('click', () => this.setSheet(!this.cart.hasAttribute('data-open')));
        this.cart.addEventListener('keydown', (evt) => this.trapSheet(evt));
        this.bindSheetDrag();

        /* The "view more" cues follow both scrollers and any size change, and
           scroll toward what they point at: one row for the list, most of a
           screen for the body. */
        const body = this.root.querySelector('.js-ssb-body');
        const smooth = () => (reduceMotion() ? 'auto' : 'smooth');
        const listCue = this.root.querySelector('.js-ssb-more');
        const bodyCue = this.root.querySelector('.js-ssb-more-body');
        if (listCue) listCue.addEventListener('click', () => this.linesBox.scrollBy({ top: 72, behavior: smooth() }));
        if (bodyCue && body) bodyCue.addEventListener('click', () => body.scrollBy({ top: Math.round(body.clientHeight * 0.8), behavior: smooth() }));
        const onScroll = () => this.updateMore();
        this.linesBox.addEventListener('scroll', onScroll, { passive: true });
        if (body) body.addEventListener('scroll', onScroll, { passive: true });
        if (window.ResizeObserver) {
          const ro = new ResizeObserver(() => this.updateMore());
          ro.observe(this.linesBox);
          ro.observe(this.items);
          if (body) ro.observe(body);
        }

        /* The rail is never capped or scrolled (review round 5). Its height
           goes to --ssb-rail-h, which the CSS uses to pin it by the bottom
           when the window is too short for it. Measured when its size
           changes, never on scroll: the 2026-08 build re-measured on every
           scroll frame and the cart jumped (review round 1). */
        const railHeight = () => {
          if (desktopMQ.matches) this.shell.style.setProperty('--ssb-rail-h', this.shell.offsetHeight + 'px');
          else this.shell.style.removeProperty('--ssb-rail-h');
        };
        if (window.ResizeObserver) new ResizeObserver(railHeight).observe(this.shell);
        const sync = () => {
          railHeight();
          if (desktopMQ.matches) {
            this.cart.removeAttribute('data-open');
            this.cart.removeAttribute('role');
            this.cart.removeAttribute('aria-modal');
            this.cart.style.removeProperty('height');
          } else {
            this.setSheet(this.cart.hasAttribute('data-open'), true);
          }
          this.updateMore();
        };
        desktopMQ.addEventListener('change', sync);
        /* matchMedia only fires at the boundary — a rotation or URL-bar
           collapse never crosses it, so listen to resize as well. Cancel and
           re-request, never a ticking flag that one lost frame can latch. */
        window.addEventListener('resize', () => {
          cancelAnimationFrame(this._resize);
          this._resize = requestAnimationFrame(() => { if (this.cart.hasAttribute('data-open')) this.sizeSheet(); this.updateMore(); });
        }, { passive: true });
        sync();
      }

      /* The sheet animates height between pixel values (you can't
         transition to auto). Closed is the CSS 84px; open is measured. */
      setSheet(open, silent) {
        if (desktopMQ.matches) return;
        this.unpeek(true);
        this.cart.toggleAttribute('data-open', open);
        if (this.toggle) {
          this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          const l = this.toggle.querySelector('.js-ssb-toggle-label');
          if (l) l.textContent = open ? 'Hide your stack' : 'Show your stack';
        }
        if (open) {
          this.cart.setAttribute('role', 'dialog');
          this.cart.setAttribute('aria-modal', 'true');
          this.sizeSheet();
        } else {
          this.cart.removeAttribute('role');
          this.cart.removeAttribute('aria-modal');
          this.cart.style.removeProperty('height');
        }
        if (!silent && this.toggle) this.toggle.focus();
        this.updateMore();
      }

      /* Open height = the sheet's natural height, capped by its CSS max
         (85dvh). Measured with the transition off so nothing animates. */
      openSheetHeight() {
        const prev = this.cart.style.height;
        this.cart.style.transition = 'none';
        this.cart.style.height = 'auto';
        const h = this.cart.getBoundingClientRect().height;
        this.cart.style.height = prev;
        void this.cart.offsetHeight;
        this.cart.style.transition = '';
        return h;
      }

      /* Closed height = the CSS rule (84px + the safe-area inset), read by
         dropping the inline height for one measurement. */
      closedSheetHeight() {
        const prev = this.cart.style.height;
        this.cart.style.transition = 'none';
        this.cart.style.height = '';
        const h = this.cart.getBoundingClientRect().height;
        this.cart.style.height = prev;
        void this.cart.offsetHeight;
        this.cart.style.transition = '';
        return h;
      }

      sizeSheet() {
        if (desktopMQ.matches) return;
        const natural = this.openSheetHeight();
        this.cart.style.height = natural + 'px';
      }

      /* Drag the grab line / title row. The sheet follows the finger, then
         settles open or closed: a flick (> 0.5px/ms) goes the way it was
         thrown, otherwise past 30% of the way is enough to change state.
         Under 6px of movement is a tap, which toggles. Buttons in the head
         (the chevron) keep their own click. */
      bindSheetDrag() {
        const head = this.root.querySelector('.js-ssb-cart-head');
        if (!head) return;
        let g = null;
        head.addEventListener('pointerdown', (e) => {
          if (desktopMQ.matches || e.target.closest('button')) return;
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          const open = this.cart.hasAttribute('data-open');
          const from = this.cart.getBoundingClientRect().height;
          this.unpeek(true); /* a drag mid-peek starts from the peek height */
          g = { y0: e.clientY, from, open, moved: false, lastY: e.clientY, lastT: performance.now(), v: 0,
                min: this.closedSheetHeight(), max: open ? from : this.openSheetHeight() };
          try { head.setPointerCapture(e.pointerId); } catch (err) { /* released */ }
        });
        head.addEventListener('pointermove', (e) => {
          if (!g) return;
          const dy = e.clientY - g.y0;
          if (!g.moved && Math.abs(dy) < 6) return;
          if (!g.moved) { g.moved = true; this.cart.classList.add('is-dragging'); }
          const h = Math.min(g.max, Math.max(g.min, g.from - dy));
          this.cart.style.height = h + 'px';
          const now = performance.now();
          g.v = (g.lastY - e.clientY) / Math.max(1, now - g.lastT);
          g.lastY = e.clientY;
          g.lastT = now;
        });
        const end = () => {
          if (!g) return;
          const s = g;
          g = null;
          if (!s.moved) return this.setSheet(!s.open, true);
          const h = this.cart.getBoundingClientRect().height;
          this.cart.classList.remove('is-dragging');
          void this.cart.offsetHeight;
          const progress = (h - s.min) / Math.max(1, s.max - s.min);
          let open;
          if (s.v > 0.5) open = true;
          else if (s.v < -0.5) open = false;
          else open = s.open ? progress > 0.7 : progress > 0.3;
          this.setSheet(open, true);
        };
        head.addEventListener('pointerup', end);
        head.addEventListener('pointercancel', end);
      }

      /* Open sheet = modal dialog: Tab cycles inside it, Escape closes it. */
      trapSheet(evt) {
        if (!this.cart.hasAttribute('data-open') || desktopMQ.matches) return;
        if (evt.key === 'Escape') { evt.preventDefault(); return this.setSheet(false); }
        if (evt.key !== 'Tab') return;
        const f = Array.from(this.cart.querySelectorAll('button:not([disabled]), input, [tabindex="0"]')).filter((el) => el.offsetParent !== null);
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (evt.shiftKey && document.activeElement === first) { evt.preventDefault(); last.focus(); }
        else if (!evt.shiftKey && document.activeElement === last) { evt.preventDefault(); first.focus(); }
      }

      /* ══════════════════════════════════════════════════════════════════
         CHECKOUT — a Recharge dynamic bundle is submitted as a whole, so
         Add to Builder is local and only this button touches the cart.
         ══════════════════════════════════════════════════════════════════ */
      bindCheckout() {
        const cta = this.root.querySelector('.js-ssb-checkout');
        cta.addEventListener('click', () => this.submit(cta));
      }

      async submit(cta) {
        if (this.submitting) return;
        const q = this.quote();
        if (q.count < (parseInt(this.root.dataset.atcMinItems, 10) || 1)) return;
        this.submitting = true;
        cta.disabled = true;
        cta.setAttribute('aria-busy', 'true');
        this.root.querySelector('.js-ssb-cart-err').textContent = '';
        const label = this.root.querySelector('.js-ssb-checkout-label');
        label.textContent = 'Adding…';
        try {
          const items = await this.buildCartItems(q);
          if (!items || !items.length) throw new Error('No cart items were produced.');
          /* STRING url: theme.liquid:473 patches fetch and fires the drawer
             refresh only when args[0] is a string. */
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!res.ok) {
            let detail = '';
            try { const b = await res.json(); detail = b.description || b.message || ''; } catch (e) { /* not JSON */ }
            throw new Error(detail || 'Cart rejected the request.');
          }
          const cart = await res.json();
          /* No pubsub here: bubbling CustomEvents, for all three drawer
             candidates (Alchemy, Recharge Storefront Experiences, Rebuy). */
          this.root.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { cart, variantId: q.lines[0] && q.lines[0].variantId } }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          this.announce('Your stack of ' + q.count + (q.count === 1 ? ' product' : ' products') + ' was added to your cart.');
        } catch (err) {
          this.root.querySelector('.js-ssb-cart-err').textContent = 'We could not add your stack. Nothing has changed — please try again.';
          this.announce('Your stack could not be added to the cart.');
          console.warn('[stack & save v2] add to cart failed.', err);
        } finally {
          this.submitting = false;
          cta.removeAttribute('aria-busy');
          this.render();
        }
      }

      /* Recharge generates the line items, including the _rc_bundle*
         properties. We never author them: _rc_bundle carries a nano id
         Recharge reconstructs the selection from, so an invented one renders
         in the cart and then fails at checkout. */
      async buildCartItems(q) {
        const api = this.rechargeApi();
        if (!api || typeof api.getDynamicBundleItems !== 'function') {
          throw new Error('Recharge bundle SDK unavailable — refusing to build a bundle by hand.');
        }
        const planId = this.subscribe ? this.root.dataset.sellingPlanId : '';
        const bundle = {
          externalProductId: String(this.root.dataset.parentProductId),
          externalVariantId: String(await this.parentVariantFor(q.count, this.root.dataset.parentVariantId)),
          selections: q.lines.map((l) => {
            const s = { collectionId: String(l.collectionId || ''), externalProductId: String(l.id), externalVariantId: String(l.variantId), quantity: l.qty };
            if (planId) s.sellingPlan = String(planId);
            return s;
          })
        };
        return api.getDynamicBundleItems(bundle);
      }

      async parentVariantFor(count, fallback) {
        const settings = await this.loadBundleSettings();
        const variants = (settings && settings.variants) || [];
        if (!variants.length) return fallback;
        const match = variants.find((v) => {
          const min = Number(v.item_count_min ?? v.itemCountMin ?? v.item_count ?? NaN);
          const max = Number(v.item_count_max ?? v.itemCountMax ?? v.item_count ?? NaN);
          if (Number.isFinite(min) && count < min) return false;
          if (Number.isFinite(max) && count > max) return false;
          return true;
        });
        const c = match || variants[0];
        return c.external_variant_id ?? c.externalVariantId ?? c.id ?? fallback;
      }

      /* ── RECHARGE ADAPTER — the only place to change if the SDK is
         exposed under a different name. UNVERIFIED on a live storefront. ── */
      rechargeApi() {
        if (this._rc !== undefined) return this._rc;
        const g = window;
        const roots = [g.recharge && g.recharge.bundle, g.Recharge && g.Recharge.bundle, g.rechargeStorefront && g.rechargeStorefront.bundle, g.recharge, g.Recharge];
        this._rc = roots.find((r) => r && typeof r.getDynamicBundleItems === 'function') || null;
        if (!this._rc) {
          this._sdkMissing = true;
          console.warn('[stack & save v2] Recharge bundle SDK not found on this page. Pricing is computed locally and Add to Cart is disabled. Confirm how the client is exposed and update rechargeApi().');
        }
        return this._rc;
      }

      async loadBundleSettings() {
        if (this._settings !== undefined) return this._settings;
        const api = this.rechargeApi();
        const productId = this.root.dataset.parentProductId;
        this._settings = null;
        if (api && typeof api.getCDNBundleSettings === 'function' && productId) {
          try { this._settings = await api.getCDNBundleSettings(productId); }
          catch (err) { console.warn('[stack & save v2] getCDNBundleSettings failed.', err); }
        }
        return this._settings;
      }

      async initTiers() {
        const parsed = this.parseTiers(await this.loadBundleSettings());
        if (parsed && parsed.length) this._tiers = parsed;
        else {
          this._tiersAreFallback = true;
          console.warn('[stack & save v2] Tier configuration could not be read from Recharge. Showing the design ladder (2/3/4 → 5/10/20%) for display only; Add to Cart is disabled.');
        }
        this._nudgeKey = null;
        this.renderLadder();
        this.render();
      }

      parseTiers(settings) {
        if (!settings) return null;
        const raw = settings.tiered_discounts || settings.tieredDiscounts || (settings.discount && settings.discount.tiers) || null;
        if (!Array.isArray(raw)) return null;
        return raw
          .map((t) => ({ min: Number(t.quantity_min ?? t.quantityMin ?? t.min ?? t.quantity), pct: Number(t.discount_percentage ?? t.discountPercentage ?? t.percentage ?? t.pct) }))
          .filter((t) => Number.isFinite(t.min) && Number.isFinite(t.pct))
          .sort((a, b) => a.min - b.min);
      }

      /* Recharge rejects a product chosen from a collection that isn't in
         the bundle's option_sources. Hide those categories (and their chips)
         and say so, rather than fail at add time. */
      async reconcileCategories() {
        const settings = await this.loadBundleSettings();
        if (!settings) return;
        const sources = [].concat(...(settings.variants || []).map((v) => v.option_sources || []))
          .map((s) => String(s.collection_id ?? s.id ?? s.external_collection_id ?? '')).filter(Boolean);
        if (!sources.length) return;
        const dropped = [];
        this.groups.forEach((g) => {
          if (sources.includes(String(g.dataset.collectionId))) return;
          g.hidden = true;
          g.dataset.unsupported = 'true';
          dropped.push(g.querySelector('h3').textContent.trim());
          const chip = this.chips.find((c) => c.dataset.category === g.dataset.category);
          if (chip) chip.hidden = true;
        });
        if (dropped.length) {
          console.warn('[stack & save v2] These categories are not in the Recharge bundle\'s option sources and have been hidden: ' + dropped.join(', ') + '. Add the collections in Recharge admin, or remove the blocks.');
        }
      }

      /* ── QUICK VIEW — the theme's <modal-dialog> supplies Escape, focus
         trap, scrim and scroll lock; this only fills it. ───────────────── */
      bindQuickView() {
        this.qv = this.root.querySelector('.js-ssb-qv');
        if (!this.qv) return;
        this.qvImages = [];
        this.qvIndex = 0;
        this.root.addEventListener('click', (evt) => {
          const link = evt.target.closest('.js-ssb-qv-open');
          if (link) this.openQuickView(link);
        });
        const prev = this.qv.querySelector('.js-ssb-qv-prev');
        const next = this.qv.querySelector('.js-ssb-qv-next');
        if (prev) prev.addEventListener('click', () => this.showImage(this.qvIndex - 1));
        if (next) next.addEventListener('click', () => this.showImage(this.qvIndex + 1));
        /* The theme fires no close event; watch the attribute instead. */
        new MutationObserver(() => { if (!this.qv.hasAttribute('open')) this.returnControls(); })
          .observe(this.qv, { attributes: true, attributeFilter: ['open'] });
      }

      catalog() {
        if (this._catalog) return this._catalog;
        try { this._catalog = JSON.parse((this.root.querySelector('.js-ssb-data') || {}).textContent || '{}'); }
        catch (e) { this._catalog = {}; }
        return this._catalog;
      }

      openQuickView(link) {
        const card = link.closest('.js-ssb-card');
        const data = card && this.catalog()[card.dataset.productId];
        if (!data) return;
        const q = (sel) => this.qv.querySelector(sel);
        q('.js-ssb-qv-name').textContent = data.title || '';
        q('.js-ssb-qv-short').innerHTML = data.shortDescription || '';
        const p = this.productFrom(card.dataset.productId);
        q('.js-ssb-qv-price').textContent = this.money(p.price);
        const was = q('.js-ssb-qv-was');
        const sel = card.querySelector('.js-ssb-flavor');
        const opt = sel && sel.selectedOptions[0];
        const compare = parseInt((opt && opt.dataset.compare) || card.dataset.compare, 10) || 0;
        was.hidden = !(compare > p.price);
        was.textContent = this.money(compare);
        const about = q('.js-ssb-qv-about');
        about.textContent = '';
        if (data.description) {
          const h = document.createElement('h3');
          h.textContent = 'About ' + data.title;
          const body = document.createElement('div');
          body.className = this.cls('qv-about-body');
          body.innerHTML = data.description;
          about.append(h, body);
        }
        about.hidden = !data.description;
        this.borrowControls(card);
        this.buildGallery(data);
        if (typeof this.qv.open === 'function') this.qv.open(link);
        else this.qv.setAttribute('open', '');
      }

      /* The flavour select and the Add to Builder pill are MOVED into the
         modal and returned on close — one control, one state, no dupes. */
      borrowControls(card) {
        const slot = this.qv.querySelector('.js-ssb-qv-controls');
        this.returnControls();
        const sel = card.querySelector('.js-ssb-flavor');
        const label = sel ? card.querySelector('label[for="' + sel.id + '"]') : null;
        const atb = card.querySelector('.js-ssb-atb');
        const err = card.querySelector('.js-ssb-err');
        this.borrowed = [];
        [label, sel, atb, err].forEach((el) => {
          if (!el) return;
          const marker = document.createComment('ssb-borrowed');
          el.parentNode.insertBefore(marker, el);
          this.borrowed.push({ el, marker });
          slot.appendChild(el);
        });
      }

      returnControls() {
        (this.borrowed || []).forEach(({ el, marker }) => {
          if (marker.parentNode) { marker.parentNode.insertBefore(el, marker); marker.remove(); }
        });
        this.borrowed = [];
      }

      buildGallery(data) {
        this.qvImages = (data.images || []).filter(Boolean);
        const thumbs = this.qv.querySelector('.js-ssb-qv-thumbs');
        const single = this.qvImages.length <= 1;
        this.qv.querySelector('.js-ssb-qv-prev').hidden = single;
        this.qv.querySelector('.js-ssb-qv-next').hidden = single;
        thumbs.hidden = single;
        thumbs.textContent = '';
        this.qvImages.forEach((src, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = this.cls('qv-thumb');
          b.setAttribute('aria-label', 'Show image ' + (i + 1));
          const img = document.createElement('img');
          img.src = src; img.alt = ''; img.loading = 'lazy';
          b.appendChild(img);
          b.addEventListener('click', () => this.showImage(i));
          thumbs.appendChild(b);
        });
        this.showImage(0);
      }

      showImage(i) {
        if (!this.qvImages.length) return;
        const n = this.qvImages.length;
        this.qvIndex = ((i % n) + n) % n;
        this.qv.querySelector('.js-ssb-qv-main').src = this.qvImages[this.qvIndex];
        Array.from(this.qv.querySelector('.js-ssb-qv-thumbs').children)
          .forEach((b, j) => b.setAttribute('aria-current', j === this.qvIndex ? 'true' : 'false'));
      }

      closeQuickView() {
        if (typeof this.qv.close === 'function') this.qv.close();
        else this.qv.removeAttribute('open');
        this.returnControls();
      }
    }

    /* v2's own root hook and ready flag. Shopify bundles every section's
       javascript into one file on every page, so the 2026-08 rollback
       section's script is loaded here too; sharing its hook let it claim
       this section first and run the old code (the price count-up it still
       had, review round 5). */
    const init = (scope) => {
      (scope || document).querySelectorAll('.js-swol-ssb-v2').forEach((root) => {
        if (root.dataset.ssbV2Ready === 'true') return;
        root.dataset.ssbV2Ready = 'true';
        new StackBuilder(root);
      });
    };
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', () => init());
    document.addEventListener('shopify:section:load', (evt) => init(evt.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class LoadMedia extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      const deferredMediaBtn = this.closest('.video-section').querySelector('.js-load-media');
      button.addEventListener('click', () => deferredMediaBtn.click());
    }
  }
  customElements.define('load-media', LoadMedia);

  } catch(e) { console.error(e); }
})();
})();
